<template>
  <div class="comMapBox">
    
    <div class="searchMain">
      <div class="row1">
        <div class="itemWrap" style="width:100%">
          <label>行政區</label>
          <DistSelection  v-model="selectedAreaValue"  width="15%"  @area-change="handleAreaChange" />

          <el-input v-model="keyword" placeholder="公司名稱 / 統一編號 / 關鍵詞" style="width:25%;margin-right:1rem;" clearable />                    
          
          <el-button style="margin-right: 1.25rem;" type="primary" icon="el-icon-search"  @click="doSearch">查詢</el-button>
          
          <a href="#" v-if="btnHotTag" style="margin-right: 1rem;" @click="doTagsCloud"><i style="margin-right: 0.5rem;" class="el-icon-price-tag"></i>熱門標籤</a>          
          <a href="#" style="margin-right: 1rem;" @click="doClearTags"><i style="margin-right: 0.5rem;" class="el-icon-delete"></i>清空條件</a>
          <!-- <a href="#" style="margin-right: 1rem;" @click="handleSaveSearch"><i style="margin-right: 0.5rem;" class="el-icon-news"></i>儲存搜尋條件</a>
          <a href="#" style="margin-right: 1rem;" @click="showLoadSearch=true"><i style="margin-right: 0.5rem;" class="el-icon-present"></i>載入搜尋條件</a> -->
        </div>
      </div>
      
      <!-- 已選擇的標籤 -->
      <div class="rowtag" v-if="lstQuery.length > 0">
        <label style="margin-right: 1rem;">已選擇條件</label>
        <el-tag v-for="tag in lstQuery" :key="tag"  type="success" closable :disable-transitions="false" @close="handleClose(tag)">
          {{tag}}
        </el-tag>
      </div>
    </div>
    
    <!-- 進階搜尋條件 - 資本額 -->
    <div class="searchWrap" style="flex-direction: column;">
      <div class="row1">
        <label style="margin-right: 30px;">篩選條件</label>
        <div class="itemWrap">                    
            <el-dropdown placement="bottom-start" @command="comStatusChangeHandler" trigger="click">
                <span class="el-dropdown-link">
                    公司狀況<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="全部">全部</el-dropdown-item>
                    <el-dropdown-item command="營業中">營業中</el-dropdown-item>
                    <el-dropdown-item command="非營業中">非營業中</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="itemWrap">                    
            <el-dropdown placement="bottom-start" @command="comTypeChangeHandler" trigger="click">
                <span class="el-dropdown-link">
                    公司類別<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="全部">全部</el-dropdown-item>
                    <el-dropdown-item v-for="item in ComTypeList" :key="item.comType" :command="item.comType">
                        {{ item.comType }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>                    
        <div class="itemWrap">                    
            <el-dropdown placement="bottom-start" @command="orgTypeChangeHandler" trigger="click">
                <span class="el-dropdown-link">
                    組織別<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="全部">全部</el-dropdown-item>
                    <el-dropdown-item v-for="item in OrgTypeList" :key="item.comType" :command="item.comType">
                        {{ item.comType }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>            
        <div class="itemWrap">
            <el-checkbox v-model="IsCustomer"  @change="otherChangeHandler('既有客戶')">
                <label style="font-size: 13px;">既有客戶</label>
            </el-checkbox>         
        </div>         
        <div class="itemWrap">
            <el-checkbox v-model="IsInvoice"  @change="otherChangeHandler('有發票')">
                <label style="font-size: 13px;">有發票</label>
            </el-checkbox>         
        </div>                          
        <div class="itemWrap">
            <el-checkbox v-model="IsImport"  @change="otherChangeHandler('有進口')">
                <label style="font-size: 13px;">有進口</label>
            </el-checkbox>         
        </div>         
        <div class="itemWrap">
            <el-checkbox v-model="IsExport"  @change="otherChangeHandler('有出口')">
                <label style="font-size: 13px;">有出口</label>
            </el-checkbox>                  
        </div>
        <div class="itemWrap">
            <el-checkbox v-model="IsFactory"  @change="otherChangeHandler('有工廠')">
                <label style="font-size: 13px;">有工廠</label>
            </el-checkbox>           
        </div>
      </div>  
         
    </div>
    
    <!-- 其他進階條件 -->
    <div class="searchWrap">
      <div class="row2">
        <label style="margin-right: 1.25rem;">進階條件</label>
        <!-- 資本額 -->
         <el-dropdown placement="bottom-end" @command="radClick" trigger="click"> 
          <span class="el-dropdown-link">
            實收資本<i style="margin-left: 0.5rem;" class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="custom1-dropdown-menu">
            <el-dropdown-item icon="el-icon-money" v-for="c in capList" :command="c.value" :key="c.value" >
              {{c.cap}}
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-edit" command="custom">
              自訂區間
            </el-dropdown-item>                                                
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 公司設立日期 -->
        <el-dropdown placement="bottom-end" @command="yearClick" trigger="click"> 
          <span class="el-dropdown-link">
            設立年數<i style="margin-left: 0.5rem;" class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="custom1-dropdown-menu">
            <el-dropdown-item icon="el-icon-date" v-for="c in yearList" :command="c.value" :key="c.value" >
              {{c.cap}}
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-edit" command="custom">
              自訂區間
            </el-dropdown-item>                                                
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 行業代號下拉選單 -->                
        <div class="itemWrap">
            <IndusCodeSelection size="small"
              :multiple="false"
              v-model="selectedIndustryCode"
              @change="handleIndustryCodeChange"
            /> 
        </div>
        
                          
      </div>
    </div>
    
    <!-- 地圖區域 -->        
    <div class="content">
      <div class="leftContent">
        <div id="map" style="position: relative;">
          <div class="map-controls">
            <el-button type="primary" :icon="isLocating ? 'el-icon-loading' : 'el-icon-location'" circle @click="handleLocationClick" :loading="isLocating" :title="isLocating ? '正在定位中...' : '定位到我的位置'" />
          </div>
          
          <!-- Google地圖風格的懸浮按鈕 - 放在右側中間 -->
          <div v-if="!drawerVisible" class="map-drawer-toggle" @click="drawerVisible = true">
            <el-tooltip content="展開側邊面板" placement="left" effect="dark">
              <div class="button-content">
                <i class="el-icon-arrow-left drawer-icon-left"></i>
              </div>
            </el-tooltip>
          </div>
          
        </div>            
      </div>
      
      <!-- 收起側邊面板的按鈕 - 在 drawer 外部 -->
      <div 
        v-if="drawerVisible" 
        class="drawer-toggle-btn-outside" 
        ref="toggleBtn"
        @click="drawerVisible = false"
      >
        <el-tooltip content="收起側邊面板" placement="right" effect="dark">
          <i class="el-icon-arrow-right drawer-icon-right"></i>
        </el-tooltip>
      </div>
      
      <el-drawer
        title="查詢公司結果列表"
        :visible.sync="drawerVisible"
        direction="rtl"
        :size="drawerWidth"
        
        :with-header="true"
        :show-close="tabledata.length === 0"
        :close-on-click-modal="tabledata.length === 0"
        :close-on-press-escape="tabledata.length === 0"        
        :modal="false"
      >
        <!-- 將收起按鈕移到外部 -->
      
        <div class="drawer-content">
          <el-card 
            v-for="item in tabledata" 
            :key="`${item.UniComNm}-${item.Branch}`" 
            class="compact-card"
            style="margin-bottom: 0.3rem;" 
            :body-style="{ padding: '0 0.5rem' }"
          >
          <!-- 使用一個包裝 div 來容納內容和按鈕 -->
          <div class="card-container">
            <!-- 卡片內容區域 -->
            <div 
              class="card-content-wrapper" 
              @click="doshowMap(item, (tabledata.indexOf(item) + 1))"
              style="cursor: pointer;"
            >
              <div class="card-content">
                <h3>
                  <span class="item-number">{{ tabledata.indexOf(item) + 1 }}.</span>
                  <span class="unicodeBox">{{ item.UniComNm }}</span>
                </h3>          
                <p class="card-branchname"> {{ item.Branch }} </p>
                <p class="card-info"><span v-if="item.RepName">負責人: {{ item.RepName }} </span><span v-if="item.Tel">- 電話: {{ item.Tel }}</span></p>
              </div>
            </div>
            
            <!-- 右側按鈕區域 -->
            <div class="card-action-buttons">
              <div class="circular-button" @click.stop="handleTagClick(item)">
                <el-tooltip content="查看標籤" placement="top" effect="light">
                  <i class="el-icon-collection-tag"></i>
                </el-tooltip>
                <div class="button-label">標籤</div>
              </div>
              <!-- <div class="circular-button" @click.stop="handleAddPotentialCustomerClick(item.UniComNm, item.Branch, item.Latitude, item.Longitude)">
                <el-tooltip content="新增潛在客戶" placement="top" effect="light">
                  <i class="el-icon-plus"></i>
                </el-tooltip>
                <div class="button-label">客戶</div>
              </div> -->
              <div class="circular-button-green" @click.stop="doShowCompanyDetail(item)">
                <el-tooltip content="將開啟新頁" placement="top">
                  <i class="el-icon-document"></i>
                </el-tooltip>
                <div class="button-label">公司登記</div>
              </div>                            
              <div class="circular-button-green" @click.stop="doshowDetail(item)">
                <el-tooltip content="將開啟新頁" placement="top">
                  <i class="el-icon-sell"></i>
                </el-tooltip>
                <div class="button-label">企業標籤</div>
              </div>                            

            </div>
          </div>           
        </el-card>
        <!-- 分頁區域 -->
        <div class="pageBox">
          <PageBrief @currentChange="pageChange" :pageSize="this.listQuery.Page_Size" :propsCurrentPage="this.listQuery.Page_Num" :totalLists="totalLists" />
        </div>
      </div>
      </el-drawer>
      
      <!-- 左側標籤抽屜 -->
      <el-drawer
        :title="(selectedCompanyTags.company && selectedCompanyTags.company.Branch ? selectedCompanyTags.company.Branch : '') + ' 標籤資訊'"
        :visible.sync="tagDrawerVisible"
        direction="ltr"
        :size="tagDrawerWidth"
        :with-header="true"
        :show-close="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        :modal="false"
      >
        <div class="tag-drawer-content" v-if="selectedCompanyTags.company">
          <!-- 公司基本資訊 -->
          <div class="company-info-section">
            <h3 class="section-title">
              <i class="el-icon-office-building"></i>
              公司資訊
            </h3>
            <div class="company-details">
              <p><strong>公司名稱：</strong>{{ selectedCompanyTags.company.Branch }}</p>
              <p><strong>統一編號：</strong>{{ selectedCompanyTags.company.UniComNm }}</p>
              <p v-if="selectedCompanyTags.company.RepName"><strong>負責人：</strong>{{ selectedCompanyTags.company.RepName }}</p>
              <p v-if="selectedCompanyTags.company.ComLoc"><strong>地址：</strong>{{ selectedCompanyTags.company.ComLoc }}</p>
              <p v-if="selectedCompanyTags.company.Tel"><strong>電話：</strong>{{ selectedCompanyTags.company.Tel }}</p>
              <p v-if="selectedCompanyTags.company.Cap"><strong>資本額：</strong>{{ capFormat(selectedCompanyTags.company.Cap) }}</p>
              <p v-if="selectedCompanyTags.company.EstDate"><strong>設立日期：</strong>{{ selectedCompanyTags.company.EstDate }}</p>
              <p v-if="selectedCompanyTags.company.IndustryName"><strong>行業：</strong>{{ selectedCompanyTags.company.IndustryName }}</p>
            </div>
          </div>
          
          <!-- 總行標籤區域 -->
          <div class="tags-section" v-if="splitHqTags && splitHqTags.length > 0">
            <h3 class="section-title">
              <i class="el-icon-collection-tag"></i>
              總行標籤 ({{ splitHqTags.length }})
            </h3>
            <div class="tags-container">
              <el-tag
                v-for="(tag, index) in splitHqTags"
                :key="`cu-${index}`"
                type="success"
                size="small"
                class="tag-item"
              >
                <a href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '總行標籤')" style="color: #67c23a;text-decoration: none;">
                  {{ tag.name }}
                </a>
              </el-tag>
              <div v-if="splitHqTags.length === 0" class="no-tags">
                <i class="el-icon-info"></i>
                暫無總行標籤
              </div>
            </div>
          </div>
          
          <!-- 自訂標籤區域 -->
          <div class="tags-section" v-if="splitBrTags && splitBrTags.length > 0">
            <h3 class="section-title">
              <i class="el-icon-collection"></i>
              自訂標籤 ({{ splitBrTags.length }})
            </h3>
            <div class="tags-container">
              <el-tag
                v-for="(tag, index) in splitBrTags"
                :key="`br-${index}`"
                type="success"
                size="small"
                class="tag-item"
              >
                <a href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '自訂標籤')" style="color: #67c23a;text-decoration: none;">
                  {{ tag.name }}
                </a>
              </el-tag>
              <div v-if="splitBrTags.length === 0" class="no-tags">
                <i class="el-icon-info"></i>
                暫無自訂標籤
              </div>
            </div>
          </div>

          
          
          <!-- 標準標籤 -->
          <div class="tags-section" v-if="splitStdTags && splitStdTags.length > 0">
            <h3 class="section-title">
              <i class="el-icon-collection-tag"></i>
              標準標籤 ({{ splitStdTags.length }})
            </h3>
            <div class="tags-container">
              <el-tag
                v-for="(tag, index) in splitStdTags"
                :key="`std-${index}`"
                type="success"
                size="small"
                class="tag-item"
              >
                <a
                  v-if="tag.isHyperLink"
                  href="javascript:void(0)"
                  @click="handleTagClick(tag.name, tag.category || '', '標準標籤')"
                  style="color: #67c23a;text-decoration: none;"
                >
                  {{ tag.name }}
                </a>
                <span v-else>
                  {{ tag.name }}
                </span>
              </el-tag>
              <div v-if="splitStdTags.length === 0" class="no-tags">
                <i class="el-icon-info"></i>
                暫無標準標籤
              </div>
            </div>
          </div>

          <!-- 當沒有任何標籤時的提示 -->
          <div v-if="(!splitBrTags || splitBrTags.length === 0) && (!splitHqTags || splitHqTags.length === 0)" class="no-tags-message">
            <el-empty description="此公司暫無標籤資訊">
              <i class="el-icon-collection-tag" style="font-size: 64px; color: #ddd;"></i>
            </el-empty>
          </div>
          
          <!-- 操作按鈕區域 -->
          <div class="tag-actions" v-if="btnAdvFuncVisible">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="openAddTagDialog">
              新增標籤
            </el-button>
            <!-- <el-button type="info" icon="el-icon-edit" size="small">
              編輯標籤
            </el-button>
            <el-button type="success" icon="el-icon-document" size="small" @click="handleDetailClick(selectedCompanyTags.company)">
              查看明細
            </el-button> -->
          </div>
        </div>
      </el-drawer>
      
    </div>  

    

    
    <!-- 輸入搜尋距離的對話框 -->
    <el-dialog title="尋找附近潛在客戶" :visible.sync="showDistanceDialog" width="25rem" center>
      <div>
        <label>請輸入距離（公里）：</label>
        <el-input-number v-model="searchDistance" :min="1" :max="20" label="距離(公里)" style="margin-left:0.5rem;" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmDistanceSearch">確定</el-button>
        <el-button @click="cancelDistanceSearch">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="熱門標籤" :visible.sync="showTagCloud" width="60%" center>
        <div class="dialogBox" >
                <div style="text-align: center;color: #FF0000; margin-bottom: 20px;">
                    <h2>請點選以下的文字</h2>
                </div>
                <div style="cursor: pointer;">
                    <wordcloud
                        :data="hotTagsList"
                        nameKey="TagName"
                        valueKey="Weight"
                        :rotate="rotateText"
                        :color="myColors"
                        :showTooltip="false"
                        :wordClick="wordClickHandler"
                        :fontSize="[35, 50]"
                        :fontSizeRatio="1.2"
                        :padding="50">
                    </wordcloud>
                </div>
        </div>
        <span slot="footer" class="dialog-footer">                
            <el-button type="danger"  @click="showTagCloud=false" ><font-awesome-icon icon="times"  style="margin-right:0.5rem;" />關閉</el-button>
        </span>
    </el-dialog>


    <el-dialog title="新增潛在客戶" :visible.sync="showCustomer" width="40%" center>
        <div class="dialogBox" >
            <div class="projMaintain__searchBox--sort">
                <h2>公司名稱 : {{ addCustomer.ComName  }} </h2>                
            </div>
            <hr/>
            <div class="projMaintain__searchBox--sort">
                <label>專案名稱：</label>
                <el-select v-model="selectedProjectName" placeholder="請選擇分類" no-data-text="無數據" @change="getDeptList">
                    <el-option label="請選擇" value=""></el-option>
                    <el-option :label="item.ProjectName" :value="item.ID" v-for="item in ProjectNameList" :key="item.ID"></el-option>
                </el-select>
                <el-dropdown trigger="click" style="margin-left: 20px;" @command="handleProjectName">
                    <el-button type="primary">
                        <font-awesome-icon icon="cog" style="margin: auto 10px;" />操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="add">
                            <font-awesome-icon icon="plus" style="margin-right:8px;" />新增專案名稱
                        </el-dropdown-item>
                        <el-dropdown-item command="edit">
                            <font-awesome-icon icon="edit" style="margin-right:8px;" />修改專案名稱
                        </el-dropdown-item>
                        <el-dropdown-item command="delete">
                            <font-awesome-icon icon="trash" style="margin-right:8px;" />刪除專案名稱
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>                
            </div>

            <!-- 加入潛在客戶的原因 -->
            <!-- <div class="projMaintain__searchBox--theme" style="margin-top:20px;">
                <label>備註：</label>
                <el-input type="textarea" rows="2" v-model="reasonDesc"  placeholder="簡明描述推薦加入潛在客戶的原因" style="width:100%;margin-right:15px;margin-top:15px" clearable></el-input>                                       
            </div>                 -->
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button v-if="btnAdvFuncVisible" type="primary"  @click="saveCustomer()" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />新增</el-button>
                <el-button type="danger"  @click="showCustomer=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        </span>
    </el-dialog>         

    <!-- 新增標籤對話框 -->
    <el-dialog title="新增標籤" :visible.sync="showAddTagDialog" width="30%" center>
      <div class="tag-form">
        <!-- 顯示公司名稱 -->
        <div class="form-item">
          <label>公司名稱</label>
          <div class="company-name">{{ selectedCompanyTags.company ? selectedCompanyTags.company.Branch : '請先選擇公司' }}</div>
        </div>
        <!-- 標籤輸入框 , 如果 RoleName 是 HE, HD, HC, HC1  時, 才會顯示出來-->
        <div class="form-item" v-if="newTagForm.type=='hq'"> 
          <label>標籤類型</label>
          <el-radio-group v-model="newTagFormType" style="display: inline-flex; gap: 10px;">
            <el-radio label="hq" >總行標籤</el-radio>
            <el-radio label="br">自訂標籤</el-radio>
          </el-radio-group>
        </div>        
        
        <!-- 標籤輸入框 -->
        <div class="form-item">
          <label>標籤內容(可輸入多個標籤用逗號, 隔開)</label>
          <el-input v-model="newTagForm.content" placeholder="請輸入標籤內容"></el-input>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button v-if="btnAdvFuncVisible" type="primary" @click="saveNewTag">儲存</el-button>
        <el-button @click="showAddTagDialog = false">取消</el-button>        
      </span>
    </el-dialog>

    <el-dialog title="儲存查詢條件" :visible.sync="showSaveSearch" width="50%" center>
        <div class="dialogBox" >
            <div style="margin: 5px 5px">
                <label>條件名稱：</label> <el-input v-model="ssName" placeholder="輸入儲存條件的名稱" style="width:35%;margin-right:15px;" clearable></el-input>                    
            </div>                
            <div style="margin: 5px 5px">
                <label>查詢條件：</label>
                <el-tag :key="tag" class="tagsClass" v-for="tag in lstQuery" type="success" closable :disable-transitions="false" @close="handleClose(tag)">
                    {{tag}}
                </el-tag>
            </div>
            <!-- 加入潛在客戶的原因 -->
            <div style="margin: 5px 5px;">
                <label>條件備註：</label>
                <el-input type="textarea" rows="2" v-model="ssDesc"  placeholder="簡明描述儲存此查詢條件的原因" style="width:100%;margin-right:15px;margin-top:15px" clearable></el-input>                    
            </div>                
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary"  @click="saveSearch()" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />新增</el-button>
                <el-button type="danger"  @click="showSaveSearch=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        </span>
    </el-dialog>           

    <el-dialog title="載入搜尋條件" :visible.sync="showLoadSearch" width="50%" center>
        <div class="dialogBox" >
            <div style="margin: 5px 5px">
                <label>條件名稱：</label> 
                <el-select v-model="selSaveSearch" placeholder="請選擇分類" no-data-text="無數據" @change="changeSaveSearch">
                    <el-option label="請選擇" value=""></el-option>
                    <el-option :label="item.name" :value="item.name" v-for="item in saveSearchList" :key="item.name"></el-option>
                </el-select>
            </div>                
            <div style="margin: 5px 5px">
                <label>查詢條件：</label>
                <el-tag :key="tag" class="tagsClass" v-for="tag in lstLoadQuery" type="success" closable :disable-transitions="false" @close="handleClose(tag)">
                    {{tag}}
                </el-tag>
            </div>
            <!-- 加入潛在客戶的原因 -->
            <div style="margin: 5px 5px;">
                <label>條件備註：</label>
                <el-input type="textarea" rows="2" v-model="lssDesc"  placeholder="簡明描述儲存此查詢條件的原因" style="width:100%;margin-right:15px;margin-top:15px" clearable></el-input>                    
            </div>                
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary"  @click="loadSaveSearch()" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />載入</el-button>
                <el-button type="danger"  @click="showLoadSearch=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        </span>
    </el-dialog>

    <!-- 自訂資本額區間對話框 -->
    <el-dialog title="自訂資本額區間" :visible.sync="showCustomCapital" width="40%" center>
        <div class="dialogBox">
            <el-form label-width="100px">
                <el-form-item label="起始金額">
                    <el-input v-model="customCapital.start" placeholder="請輸入起始金額（萬元）" type="number">
                        <template slot="append">萬元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="結束金額">
                    <el-input v-model="customCapital.end" placeholder="請輸入結束金額（萬元）" type="number">
                        <template slot="append">萬元</template>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmCustomCapital"><font-awesome-icon icon="check" style="margin-right:5px;" />確定</el-button>
            <el-button type="danger" @click="showCustomCapital=false"><font-awesome-icon icon="times" style="margin-right:5px;" />取消</el-button>
        </span>
    </el-dialog>

    <!-- 自訂設立日期區間對話框 -->
    <el-dialog title="自訂設立日期區間" :visible.sync="showCustomYear" width="40%" center>
        <div class="dialogBox">
            <el-form label-width="100px">
                <el-form-item label="起始年限">
                    <el-input v-model="customYear.start" placeholder="請輸入起始年限（年）" type="number">
                        <template slot="append">年</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="結束年限">
                    <el-input v-model="customYear.end" placeholder="請輸入結束年限（年）" type="number">
                        <template slot="append">年</template>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmCustomYear"><font-awesome-icon icon="check" style="margin-right:5px;" />確定</el-button>
            <el-button type="danger" @click="showCustomYear=false"><font-awesome-icon icon="times" style="margin-right:5px;" />取消</el-button>
        </span>
    </el-dialog>   

  </div>
</template>

<script>

import wordcloud from 'vue-wordcloud';
import PageBrief from '../../components/PageBrief.vue';
import DistSelection from '../../components/DistSelection.vue'; // 新增引入
import { notify, handleError } from '../../utils/notify';
import IndusCodeSelection from '@/components/IndusCodeSelection.vue'

import 'leaflet-contextmenu'; 
import 'leaflet-contextmenu/dist/leaflet.contextmenu.css';

export default {
  components: { 
    PageBrief,
    DistSelection, // 註冊新組件
    IndusCodeSelection,
    wordcloud
  },
  
  data() {
    return {
      // 控制按鈕 如果是DO, APA, AP 角色, 則 無儲存, 載入搜尋條件及新增標籤, 新增潛在客戶 功能
      btnAdvFuncVisible: false, // 控制進階功能按鈕的顯示與隱藏

      userInfo: {}, // 使用者登入資訊
      newTagFormType: 'br', // 預設為自訂標籤
      drawerVisible: false,
      drawerWidth: '30%', // 抽屜的寬度，與 el-drawer 的 size 屬性一致
      mapInitialized: false, // 用於跟踪地圖是否已經初始化

      showSaveSearch: false,
      showLoadSearch: false,
      ssName: "",
      ssDesc: "",
      selSaveSearch: "",
      saveSearchList: [],
      lstLoadQuery: [],
      lssDesc: "",
      preciseTagMappings: [
        { key: 'invest_area', title: '對外投資', isHyperlink: true },
        { key: 'is_china_fund', title: '陸資來台投資', isHyperlink: true },
        { key: 'is_invest_china', title: '赴中國大陸投資', isHyperlink: true },
        { key: 'award_name', title: '獲獎記錄', isHyperlink: true },
        { key: 'certification', title: '專業認證', isHyperlink: true },
        { key: 'domain_name', title: '企業領域', isHyperlink: true },
        { key: 'brand_name', title: '品牌商標', isHyperlink: true },
        { key: 'park_name', title: '所在園區', isHyperlink: true },
        { key: 'alarm_item', title: '裁罰警示', isHyperlink: true },
        { key: 'industry', title: '相關產業', isHyperlink: true },
        { key: 'industry_type', title: '相關產業', isHyperlink: true },
        { key: 'product', title: '相關產品', isHyperlink: true },
        { key: 'hq_category', title: '總行標籤', isHyperlink: true },
        { key: 'br_category', title: '自訂標籤', isHyperlink: true },
        { key: 'company_type', title: '公司類別', isHyperlink: true },
        { key: 'is_import', title: '進口廠商', isHyperlink: true },
        { key: 'is_export', title: '出口廠商', isHyperlink: true },
        { key: 'is_supplier', title: '合格供應商 ', isHyperlink: true },
        { key: 'import_value', title: '進口實績 ', isHyperlink: true },
        { key: 'export_value', title: '出口實績 ', isHyperlink: true },
      ],
      
      // 左側標籤抽屜相關
      tagDrawerVisible: false,
      tagDrawerWidth: '25%',
      selectedCompanyTags: {
        company: null,        
        br_tags: [],
        hq_tags: []
      },
      // 標準標籤 (新增，用於顯示標準標籤區塊)
      splitStdTags: [],
      selectedComStatus: "全部",
      selectedOrgType: "全部",
      selectedComType: "全部",
      // 標籤相關
      showAddTagDialog: false,
      newTagForm: {
        content: '',
        type: 'br' // 'hq' 或 'br'
      },

      deptInfo: {}, 
      // 地圖相關
      mapObj: {},
      tbbBranch: [],
      keelungCx: [],
      latitude: 24.9895,
      longitude: 121.5080,
      zoomDegree: 16,
      theMarkerList: [],
      activeMarker: null, // 追蹤當前活動的標記
      branchLatitude: null, // 分行緯度
      branchLongitude: null, // 分行經度
      mapConfig: {
        tileLayerUrl: process.env.VUE_APP_TILE_LAYER_URL + '/data/v3/{z}/{x}/{y}.jpg',
        minZoom: 10,
        maxZoom: 16,
        defaultCenter: [24.9895, 121.5080],
        defaultZoom: 10,
        orangeIcon: null,
        redIcon: null,
        numberIcons: {} // 存儲預載入的數字圖標
      },

      // 新增：結構化的查詢條件（用於 API 查詢）
      queryConditions: {
          keyword: '',           // 關鍵字
          companyStatus: [],     // 公司狀況, 營業中==> ['new','modify'], 非營業中==>['delete']
          companyType: [],       // 公司類別, '上市', '上櫃', '興櫃', '未上市'
          orgType: [],          // 組織別, '股份有限公司', '有限公司', '獨資', '合夥', '其他'
          isCustomer: false,    // 既有客戶
          isInvoice: false,     // 有發票
          isImport: false,      // 有進口
          isExport: false,      // 有出口
          isFactory: false,     // 有工廠
          capital: {            // 資本額
              start: '',
              end: '',
              range: ''         // 如 "0~100萬"
          },
          setupDate: {          // 設立日期
              range: '',        // 如 "1-3年"
              start: '',        // 計算後的開始日期，如 "2020-01-01"
              end: '',          // 計算後的結束日期，如 "2022-12-31"
              rangeValue: ''    // yearList 的 value
          },
          industryCode: [],     // 行業代碼
          location: {           // 地址
              area: '',         // 區域：北部/中部/南部/東部
              city: '',         // 縣市
              district: ''      // 區域
          },
          geolocation: {        // 地理位置
              Latitude: '',     // 緯度
              Longitude: '',    // 經度
              Distance: ''      // 距離，單位公里
          },
          preciseTags: [],      // 精準標籤查詢 [{ category: 'au_xxx', display_name: '關鍵字' }]
      },
      // 新增：查詢條件映射表（用於標籤與結構的對應）
      queryConditionMap: new Map(),      
      
      // 搜尋相關
      lstQuery: [],
      listQuery: {
        comLoc: "臺北市",
        SearchText: "",
        Page_Size: 10,
        Page_Num: 1
      },
      keyword: "",
      totalLists: 0,
      tabledata: [],
      selectedIndustryCode: [],
      
      // 資本額相關
      radCap: "",
      TotCapStart: "",
      TotCapEnd: "",
      // 自訂資本額區間
      showCustomCapital: false,
      customCapital: {
        start: '',
        end: ''
      },
      capList: [
        { cap: "2000萬(含)以下", value: 1, start: 0, end: 2000 },
        { cap: "2001萬~3000萬(含)以下", value: 2, start: 2001, end: 3000 },
        { cap: "3001萬~8000萬(含)以下", value: 3, start: 3001, end: 8000 },
        { cap: "8001萬~1億(含)以下", value: 4, start: 8001, end: 10000 },
        { cap: "1億(不含)以上", value: 5, start: 10001, end: 999999999 }        
      ],

      ProjectNameList: [],      
      
      // 設立日期相關
      yearCap: "",
      // 自訂設立日期區間
      showCustomYear: false,
      customYear: {
        start: '',
        end: ''
      },
      yearList: [
          { cap: "未滿1年", start: 0, end: 1, value: 1 },
          { cap: "1年以上-未滿3年", start: 1, end: 3, value: 2 },
          { cap: "3年以上-未滿5年", start: 3, end: 5, value: 3 },
          { cap: "5年以上-未滿10年", start: 5, end: 10, value: 4 },
          { cap: "10年(含)以上", start: 10, end: 20, value: 5 }          
      ],
      
      // 組織別相關
      OrgTypeList: [
        { comType: "股份有限公司" },
        { comType: "有限公司" },
        { comType: "獨資" },
        { comType: "合夥" },
        { comType: "其他" }
      ],
      ComTypeList: [
        { comType: "上市" },
        { comType: "上櫃" },
        { comType: "興櫃" },
        { comType: "公開發行" }
      ],

      industryCode: "",
      btnHotTag: false,
      
      // 地址選擇相關      
      showDistrict: false,
      selCity: "全部",
      DistList: [],

      selectedPOI: null, // 儲存選中的 POI 資訊
      selectedProjectName: "", // 新增潛在客戶用的專案ID
      addCustomer: {
        ComName:"",
        ProjectName:"",
        Desc:""
      },

      // 地區選擇相關（簡化後）
      selectedAreaValue: ['北部', '臺北市', '全部'],
      
      // 其他篩選條件
      IsImport: false,
      IsExport: false,
      IsInvoice: false,
      IsCustomer: false,
      IsFactory: false,
      
      // 標籤雲相關
      myColors: ['#1f77b4', '#629fc9', '#94bedb', '#c9e0ef'],
      hotTagsList: [],
   
      showTagCloud: false, // 控制熱門標籤顯示
      rotateText: {
        from: -0,
        to: 0,
        numOfOrientation: 5
      },      
      // 顯示控制
      showCustomer: false,
      selProjectName: "",
      selectedProjectName: "",
      selectedBranch: {},
      showDistanceDialog: false, // 控制距離輸入框顯示
      searchDistance: 1, // 預設距離（公里）
      distanceLatLng: null, // 儲存點擊的座標
      isLocating: false, // 定位狀態
      activeMarker: null, // 用於追蹤當前活動的標記
      currentCompany: null, // 當前選擇的公司資訊，用於尋找潛在客戶
    };
  },
  
  watch: {
    drawerVisible: {
      handler(newVal) {
        if (newVal) {
          // 抽屜打開後，等待 DOM 更新，然後調整按鈕位置
          this.$nextTick(() => {
            this.updateToggleButtonPosition();
          });
        }
      },
      immediate: true
    },
    
    // 🔥 新增：監控選中的 POI，確保抽屜保持開啟
    selectedPOI: {
      handler(newVal) {
        if (newVal && this.tabledata.length > 0) {
          // 當有選中的 POI 且有表格數據時，確保抽屜開啟
          this.drawerVisible = true;
        }
      },
      immediate: true
    }
  },
  
  computed: {
    // 處理br_tags字串分割
    splitBrTags() {
      if (this.selectedCompanyTags.br_tags) {        
        if (Array.isArray(this.selectedCompanyTags.br_tags)) {
            // 如果是陣列，直接返回（過濾空字串）
            console.log('自訂標籤陣列:', this.selectedCompanyTags.br_tags);
            return this.selectedCompanyTags.br_tags.filter(tag => tag && tag.name.trim().length > 0);
        }        
      }
      return [];
    },
    
    // 處理hq_tags字串分割
    splitHqTags() {
      if (this.selectedCompanyTags.hq_tags) {
        if (Array.isArray(this.selectedCompanyTags.hq_tags)) {
            // 如果是陣列，直接返回（過濾空字串）
            console.log('總行標籤陣列:', this.selectedCompanyTags.hq_tags);
            return this.selectedCompanyTags.hq_tags.filter(tag => tag && tag.name.trim().length > 0);
        }
      }
      return [];
    }
    ,

  },
  
  methods: {
    yearFormat: function(value) {
        if( value===null || value.length<4) 
            return "";
        else  {                
            return value.slice(0, 4) + '年';
        }
    },    

    // 處理標準標籤（來源可能是this.selectedCompanyTags.company.au_ 開頭 中標記為標準的項目）
    getStdTags() {

      // 二元性的標籤，不需要有hyperlink
      const binaryTagKeys = ["au_company_type","au_is_import","au_is_export","au_is_factory","au_is_supplier","au_is_china_fund"];
      console.log('原始公司資料:', this.selectedCompanyTags.company);
      let stdTags = [];
      if( this.selectedCompanyTags.company ){        
        for (const key in this.selectedCompanyTags.company) {
          if (key.startsWith('au_') && this.selectedCompanyTags.company[key] ) {
            //console.log('標準標籤屬性:', key, this.selectedCompanyTags.company[key]);

            
            this.selectedCompanyTags.company[key]?.forEach(item => {
              // let tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} ${item.name || ''}`;
              let tagStr = item.display_name || item.name || '';
              if (item.category == "export_value") {
                tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} 出口 ${item.name || ''}級`
              } 
              if (item.category == "import_value") {
                tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} 進口 ${item.name || ''}級`
              }                            
              stdTags.push({
                name: tagStr.trim(),
                category: item.category || key.replace('au_', ''),
                isHyperLink: binaryTagKeys.includes(key) ? false : true,
              });
            });
            
            // stdTags.push({ field: this.selectedCompanyTags.company[key], name: this.selectedCompanyTags.company[key] });
          }
        }
        if (stdTags.length > 0) {
          return stdTags;
        }
      }



      

      return [];
    },    

    getPreciseTagTitle(tagKey) {
      if (!tagKey) return '';
      const tagInfo = this.preciseTagMappings.find(item => item.key === tagKey);
      return tagInfo ? tagInfo.title : tagKey;
    },

    buildTagDisplayText(tag, value, fallbackDisplayText = '') {
      if (!tag) return fallbackDisplayText;
      const title = this.getPreciseTagTitle(tag);

      let keyword = '';
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        keyword = value.display_name || value.name || value.keyword || '';
      } else if (value !== null && value !== undefined) {
        keyword = String(value);
      }

      if (!keyword) return fallbackDisplayText || title;
      return `${title}:${keyword}`;
    },

    // 新增查詢條件（同時更新 lstQuery 和 queryConditions）
    addQueryCondition(type, value, displayText, tag = '') {
      const resolvedDisplayText = this.buildTagDisplayText(tag, value, displayText);

        // 1. 更新顯示標籤
      if (resolvedDisplayText && !this.lstQuery.includes(resolvedDisplayText)) {
        this.lstQuery.push(resolvedDisplayText);
        }
        
        // 2. 更新結構化資料
        switch(type) {
            case 'keyword':
                this.queryConditions.keyword = value;
                break;
                
            case 'companyStatus':
                this.queryConditions.companyStatus = value;
                break;
                
            case 'companyType':
                if (!this.queryConditions.companyType.includes(value)) {
                    this.queryConditions.companyType.push(value);
                }
                break;
                
            case 'orgType':
                if (!this.queryConditions.orgType.includes(value)) {
                    this.queryConditions.orgType.push(value);
                }
                break;
                
            case 'isCustomer':
                this.queryConditions.isCustomer = value;
                break;
                
            case 'isInvoice':
                this.queryConditions.isInvoice = value;
                break;
                
            case 'isImport':
                this.queryConditions.isImport = value;
                break;
                
            case 'isExport':
                this.queryConditions.isExport = value;
                break;
                
            case 'isFactory':
                this.queryConditions.isFactory = value;
                break;
                
            case 'capital':
                this.queryConditions.capital = value;
                break;
                
            case 'setupDate':
                this.queryConditions.setupDate = value;
                break;
                
            case 'industryCode':
                // 目前只支援單選
                // this.queryConditions.industryCode = [value];
                // 以下是支援複選
                if (!this.queryConditions.industryCode.includes(value)) {
                    this.queryConditions.industryCode.push(value);
                }
                break;
                
            case 'location':
                this.queryConditions.location = value;
                break;

            case 'geolocation':
                this.queryConditions.geolocation = value;
                break;

            case 'preciseTag': {
                const preciseTag = value && typeof value === 'object'
                    ? {
                  category: value.category || tag,
                        display_name: value.display_name || value.name || ''
                    }
                : { category: tag, display_name: value };

                if (!Array.isArray(this.queryConditions.preciseTags)) {
                    this.queryConditions.preciseTags = [];
                }

                if (!preciseTag.category || !preciseTag.display_name) {
                    break;
                }

                const exists = this.queryConditions.preciseTags.some(item =>
                    item.category === preciseTag.category &&
                    (item.display_name || item.name) === preciseTag.display_name
                );

                if (!exists) {
                    this.queryConditions.preciseTags.push(preciseTag);
                }
                break;
            }
        }
        
        // 3. 建立映射關係（標籤文字 -> 條件類型和值）
        this.queryConditionMap.set(resolvedDisplayText, { type, value, tag });
        
        // console.log('查詢條件已更新:', {
        //     displayTags: this.lstQuery,
        //     structuredData: this.queryConditions,
        //     mapping: Array.from(this.queryConditionMap.entries())
        // });
    },
    
    // 移除查詢條件
    removeQueryCondition(displayText, tag = '') {
      const resolvedDisplayText = this.buildTagDisplayText(tag, this.queryConditionMap.get(displayText)?.value || displayText, displayText);

        // 1. 從顯示標籤中移除
      const index = this.lstQuery.indexOf(resolvedDisplayText);
        if (index > -1) {
            this.lstQuery.splice(index, 1);
        }
        
        // 2. 從結構化資料中移除
      const mapping = this.queryConditionMap.get(resolvedDisplayText) || this.queryConditionMap.get(displayText);
        if (mapping) {
        const { type, value, tag: mappedTag = '' } = mapping;
            
            
            switch(type) {
                case 'keyword':
                    this.queryConditions.keyword = '';
                    this.keyword = '';
                    break;
                    
                case 'companyStatus':
                    this.queryConditions.companyStatus = '';
                    this.selectedComStatus = '全部';
                    break;
                    
                case 'companyType':
                    const ctIndex = this.queryConditions.companyType.indexOf(value);
                    if (ctIndex > -1) {
                        this.queryConditions.companyType.splice(ctIndex, 1);
                    }
                    break;
                    
                case 'orgType':
                    const otIndex = this.queryConditions.orgType.indexOf(value);
                    if (otIndex > -1) {
                        this.queryConditions.orgType.splice(otIndex, 1);
                    }
                    break;
                    
                case 'isCustomer':
                    this.queryConditions.isCustomer = false;
                    this.IsCustomer = false;
                    break;
                    
                case 'isInvoice':
                    this.queryConditions.isInvoice = false;
                    this.IsInvoice = false;
                    break;
                    
                case 'isImport':
                    this.queryConditions.isImport = false;
                    this.IsImport = false;
                    break;
                    
                case 'isExport':
                    this.queryConditions.isExport = false;
                    this.IsExport = false;
                    break;
                    
                case 'isFactory':
                    this.queryConditions.isFactory = false;
                    this.IsFactory = false;
                    break;
                    
                case 'capital':
                    this.queryConditions.capital = { start: '', end: '', range: '' };
                    this.TotCapStart = '';
                    this.TotCapEnd = '';
                    this.radCap = '';
                    break;
                    
                case 'setupDate':
                    this.queryConditions.setupDate = { range: '', start: '', end: '', rangeValue: '' };
                    this.yearCap = '';
                    break;
                    
                case 'industryCode':
                    const icIndex = this.queryConditions.industryCode.indexOf(value);
                    if (icIndex > -1) {
                        this.queryConditions.industryCode.splice(icIndex, 1);
                    }
                    break;
                    
                case 'location':
                    this.queryConditions.location = { area: '', city: '', district: '' };
                    // 也要把 selectedAreaValue 重設
                    this.selectedAreaValue = ['全部', '全部'];
                    break;
                case 'geolocation':
                    this.queryConditions.geolocation = { Latitude: '', Longitude: '', Distance: '' };
                    break;

                case 'preciseTag': {
                    if (!Array.isArray(this.queryConditions.preciseTags)) {
                        this.queryConditions.preciseTags = [];
                    }
                    const preciseTag = value && typeof value === 'object'
                        ? {
                      category: value.category || mappedTag || tag,
                            display_name: value.display_name || value.name || ''
                        }
                    : { category: mappedTag || tag, display_name: value };

                    this.queryConditions.preciseTags = this.queryConditions.preciseTags.filter(item => {
                        return !(
                            item.category === preciseTag.category &&
                            (item.display_name || item.name) === preciseTag.display_name
                        );
                    });
                    break;
                }
                
            }
            
            // 3. 從映射表中移除
            this.queryConditionMap.delete(resolvedDisplayText);
            this.queryConditionMap.delete(displayText);
        }
    },
    
    // 清空所有查詢條件
    clearAllQueryConditions() {
        // 清空顯示標籤
        this.lstQuery = [];
        
        // 清空結構化資料
        this.queryConditions = {
            keyword: '',
            companyStatus: '',
            companyType: [],
            orgType: [],
            isCustomer: false,
            isInvoice: false,
            isImport: false,
            isExport: false,
            isFactory: false,
            capital: { start: '', end: '', range: '' },
            setupDate: { range: '', start: '', end: '', rangeValue: '' },
            industryCode: [],
            location: { area: '', city: '', district: '' },
            geolocation: { Latitude: '', Longitude: '', Distance: '' },
            preciseTags: []
        };
        
        // 清空映射表
        this.queryConditionMap.clear();
        
        // 清空 UI 狀態
        this.keyword = '';
        this.selectedComStatus = '全部';
        this.selectedComType = '全部';
        this.selectedOrgType = '全部';
        this.IsCustomer = false;
        this.IsInvoice = false;
        this.IsImport = false;
        this.IsExport = false;
        this.IsFactory = false;
        this.TotCapStart = '';
        this.TotCapEnd = '';
        this.radCap = '';
        this.yearCap = '';
        this.selectedIndustryCode = [];
    },

    // 更新行業代碼處理
    handleIndustryCodeChange(value, selectedItems) {
      // 支援單選：先檢查 value
      if (!value || value.length === 0) {
        return;
      }

      // 取得單一選中項（IndusCodeSelection 在單選時會傳回單一路徑）
      const selectedItem = Array.isArray(selectedItems) ? selectedItems[0] : selectedItems;

      if (!selectedItem) {
        console.warn('selectedItems 為空或無效');
        return;
      }

      // 移除先前所有的 industryCode 條件（只保留單一選項）
      for (const [tag, mapping] of Array.from(this.queryConditionMap.entries())) {
        if (mapping && mapping.type === 'industryCode') {
          this.removeQueryCondition(tag);
        }
      }

      // 取得實際代碼（取路徑最後一段作為代碼）
      const code = Array.isArray(value) ? value[value.length - 1] : value;
      const label = selectedItem.label || code;

      // 新增單一 industryCode 條件
      this.addQueryCondition('industryCode', code, label);

      // 保持選取狀態（不要清空），以便 UI 顯示當前所選
      this.selectedIndustryCode = value;
    },    

    // 更新公司狀況處理
    comStatusChangeHandler(value) {
        console.log('公司狀況變更:', value);
        
        // 先移除舊的公司狀況標籤
        const statusTags = ['全部', '營業中', '非營業中'];
        statusTags.forEach(tag => {
            if (this.lstQuery.includes(tag)) {
                this.removeQueryCondition(tag);
            }
        });
        
        // 添加新的條件
        if (value && value !== '全部') {
            if (value === '營業中') {
                const valueArray = ['new', 'modify']; // 營業中, 值為'new' or 'modify'
                this.addQueryCondition('companyStatus', valueArray, value);
            } else if (value === '非營業中') {
                const valueArray = ['delete']; // 非營業中, 值為 'delete'
                this.addQueryCondition('companyStatus', valueArray, value);
            }
        }
        
        this.selectedComStatus = value;
    },
    
    // 更新公司類別處理
    comTypeChangeHandler(value) {
        console.log('公司類別變更:', value);
        
        if (value === '全部') {
            // 移除所有公司類別標籤
            this.ComTypeList.forEach(item => {
                if (this.lstQuery.includes(item.comType)) {
                    this.removeQueryCondition(item.comType);
                }
            });
        } else {
            // 先移除 "全部" 標籤
            if (this.lstQuery.includes('全部')) {
                this.removeQueryCondition('全部');
            }
            
            // 添加新的公司類別
            this.addQueryCondition('companyType', value, value);
        }
        
        this.selectedComType = value;
    },
    
    // 更新組織別處理
    orgTypeChangeHandler(value) {
        console.log('組織別變更:', value);
        
        if (value === '全部') {
            // 移除所有組織別標籤
            this.OrgTypeList.forEach(item => {
                if (this.lstQuery.includes(item.comType)) {
                    this.removeQueryCondition(item.comType);
                }
            });
        } else {
            // 先移除 "全部" 標籤
            if (this.lstQuery.includes('全部')) {
                this.removeQueryCondition('全部');
            }
            
            // 添加新的組織別
            this.addQueryCondition('orgType', value, value);
        }
        
        this.selectedOrgType = value;
    },    
    // 開啟新增標籤對話框
    openAddTagDialog() {
      // 重置表單
      this.newTagForm.content = '';
      // 顯示對話框
      this.showAddTagDialog = true;
    },
    
    // 處理彈窗中的「新增標籤」按鈕點擊
    handleOpenAddTagDialog(UniComNm, branchName) {
      // 從公司名稱和分公司名稱中設置公司信息
      this.selectedCompanyTags.company = {
        UniComNm: UniComNm,
        Branch: `${branchName}`
      };
      
      // 顯示對話框
      this.showAddTagDialog = true;
    },
      
    // 保存新標籤
    async saveNewTag() {
      if (!this.newTagForm.content.trim()) {
        notify.warning('請輸入標籤內容');
        return;
      }
      
      if (!this.selectedCompanyTags.company) {
        notify.warning('未選擇公司');
        this.showAddTagDialog = false;
        return;
      }
      
      // 若newTagForm.content中有多個標籤，以,分隔，組成陣列
      const tagArray = this.newTagForm.content.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
      
      const params = {
            "UniComNm": this.selectedCompanyTags.company.UniComNm,
            "TagValues": tagArray
      };
      console.log('新增標籤參數:', params);
      // ##################################
      // 如果角色是. HE, HD, HC HC1, 則在POP中, 多一個選項, 讓使用者選要用什麼身份... 呼叫 add_hq_category_tag 
      // newTagFormType 'hq' 或 'br'
      // ##################################
      try {
        if (this.newTagFormType == 'hq') {
          const response = await this.$api.apitags.add_hq_category_tag(params);
          console.log('新增總公司標籤成功:', response);
          notify({ type: 'success', title: '成功', message: '已成功新增總行標籤' });
        } else {
          const response = await this.$api.apitags.add_category_tag(params);
          console.log('新增標籤成功:', response);
          notify({ type: 'success', title: '成功', message: '已成功新增自訂標籤' });
        }
        console.log('新增標籤準備reolad 頁面');
        this.newTagForm.content = '';
        // 等待10秒, 什麼都不用做, 讓後端有時間處理標籤更新
        //await new Promise(resolve => setTimeout(resolve, 10000));
        await this.getList();


      } catch (error) {
        handleError(error, this.newTagFormType == 'hq' ? '新增總公司標籤失敗' : '新增自訂標籤失敗');
        return;
      }
      
      // 關閉對話框
      this.showAddTagDialog = false;
    },

    doshowDetail(row) {
        console.log(row);

        // 開新頁面, 轉到ctmMapCx.vue頁面
        
        this.$queryRecord(this, row.Branch, 'company');  // 記錄點擊公司名
        const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
        window.open(url, '_blank');

    },    

    saveCustomer() {
        // 檢查是否選擇專案
        if (!this.selectedProjectName) {
            notify({ type: 'warning', title: '警告', message: '請先選擇專案名稱' });
            return;
        }

        const qry = {
            "UniComNm": this.addCustomer.UniComNm,
            "ComName": this.addCustomer.ComName,
            "ProjectID": this.selectedProjectName
        };
        
        console.log('新增潛在客戶:', this.addCustomer.ComName, '至專案:', this.selectedProjectName);
        
        // 呼叫 API 儲存潛在客戶
        this.$api.apipocx.pocx_create(qry).then(response => {
            console.log('新增潛在客戶成功:', response);
            if (response.statuscode == 200) {
                notify({ type: 'success', title: '成功', message: `已成功新增潛在客戶: ${this.addCustomer.ComName}` });
                this.showCustomer = false;
            } else {
                notify({ type: 'error', title: '失敗', message: `新增潛在客戶失敗: ${this.addCustomer.ComName}，原因：${response.message}` });
            }
        }).catch(error => {
            handleError(error, '新增潛在客戶失敗');
        });
    },

    async getDeptList() {
        this.$store.dispatch("loadingHandler", true);

        this.$store.dispatch("loadingHandler", false);
    },    

    async getDeptList() {
        this.$store.dispatch("loadingHandler", true);

        this.$store.dispatch("loadingHandler", false);
    },

    async changeProjectName() {
        this.$store.dispatch("loadingHandler", true);  

        this.$store.dispatch("loadingHandler", false);
    },

    // 處理下拉菜單命令
    handleProjectName(command) {
        switch(command) {
            case 'add':
                this.addProjectName();
                break;
            case 'edit':
                this.editProjectName();
                break;
            case 'delete':
                this.deleteProjectName();
                break;
            default:
                console.log('未知的命令:', command);
        }
    },    

    // 新增專案名稱
    async addProjectName() {
        // 彈出輸入對話框
        this.$prompt('請輸入新的專案名稱', '新增專案名稱', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            inputPattern: /.+/,
            inputErrorMessage: '專案名稱不可為空',
            customClass: 'custom-prompt-dialog'
        }).then(async ({ value }) => {
            // 使用者輸入的專案名稱                
            const qry = {
                "ProjectName": value.trim()
            };
            
            try {
                const res = await this.$api.apipocxpj.pocxpj_create(qry);
                console.log('新增專案名稱成功:', res);
                // 重新載入專案名稱列表
                await this.loadProjectNameList(); 
                this.selectedProjectName = res.data.ID; // 選擇剛新增的專案名稱
                notify({
                    title: "成功",
                    message: `成功新增專案名稱 "${value.trim()}"`,
                    type: "success",
                });

            } catch (err) {
                handleError(err, '新增專案名稱失敗');
            }
        }).catch(() => {
            // 使用者取消輸入
        });
    },
    // 修改專案名稱
    editProjectName() {
        // 請檢查是否有選擇專案名稱
        if (!this.selectedProjectName) {
            notify({
                title: "警告",
                message: "請先選擇要修改的專案名稱",
                type: "warning",
            });
            return;
        }

        this.$prompt('請輸入新的專案名稱', '修改專案名稱', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            inputValue: "",
            inputPattern: /.+/,
            inputErrorMessage: '專案名稱不可為空',
            customClass: 'custom-prompt-dialog'
        }).then(async ({ value }) => {
            // 使用者輸入的新的專案名稱
            const qry = {
                "ID": this.selectedProjectName,
                "ProjectName": value.trim()
            };
            
            try {
                const res = await this.$api.apipocxpj.pocxpj_update(qry);
                console.log('修改專案名稱成功:', res);

                if( res.statuscode == 200 ) {
                    await this.loadProjectNameList();
                    notify({
                        title: "成功",
                        message: `成功修改專案名稱為 "${value.trim()}"`,
                        type: "success",
                    });
                }
                else {
                    notify({
                        title: "錯誤",
                        message: `修改專案名稱失敗: ${res.message || '未知錯誤'}`,
                        type: "error",
                    });
                }
            } catch (err) {
                handleError(err, '修改專案名稱失敗');
            }
        }).catch(() => {
            // 使用者取消輸入
        });
    },
    // 刪除專案名稱
    deleteProjectName() {
        // 請檢查是否有選擇專案名稱
        if (!this.selectedProjectName) {
            notify({
                title: "警告",
                message: "請先選擇要修改的專案名稱",
                type: "warning",
            });
            return;
        }      
        // 由this.selectedProjectName, 找出專案名稱
        const proj = this.ProjectNameList.find(item => item.ID == parseInt(this.selectedProjectName));
        
        console.log('準備刪除專案名稱:', proj);
        // 彈出確認對話框
        this.$confirm(`確定要刪除專案名稱 "${proj.ProjectName}" 嗎?`, '刪除確認', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'custom-confirm-dialog'
        }).then(async () => {
            // 使用者確認刪除的處理邏輯
            console.log('刪除專案名稱:', proj.ProjectName);

            const res = await this.$api.apipocxpj.pocxpj_delete({ ID: this.selectedProjectName });

            // 從陣列中刪除所選項目
            const index = this.ProjectNameList.findIndex(item => item.ID == parseInt(this.selectedProjectName));
            if (index !== -1) {
                this.ProjectNameList.splice(index, 1);
            }
            
            // 這裡可以加入從後端刪除專案名稱的程式碼
            this.$message({
                type: 'success',
                message: '專案名稱已成功刪除'
            });
            
            // 重置選擇
            this.selectedProjectName = '';
        }).catch(() => {
            // 使用者取消刪除
            this.$message({
                type: 'info',
                message: '已取消刪除操作'
            });
        });
    },    

    // 移除之前的地點選擇標籤
    removePreviousLocationTags() {
        // 定義可能的地點相關標籤模式
        const locationPatterns = [
            // 區域名稱
            '北部', '中部', '南部', '東部',
            // 縣市名稱 (包含常見的縣市)
            '臺北市', '新北市', '桃園市', '臺中市', '臺南市', '高雄市',
            '新竹市', '新竹縣', '苗栗縣', '彰化縣', '南投縣', '雲林縣',
            '嘉義市', '嘉義縣', '屏東縣', '宜蘭縣', '花蓮縣', '臺東縣',
            '澎湖縣', '金門縣', '連江縣', '基隆市'
        ];
        
        // 移除符合地點模式的標籤
        this.lstQuery = this.lstQuery.filter(tag => {
            // 檢查是否為地點標籤
            const isLocationTag = locationPatterns.some(pattern => tag.includes(pattern)) ||
                                // 檢查是否包含"市"、"縣"、"區"等地點相關字詞
                                /.*[市縣區鄉鎮].*/.test(tag) ||
                                // 檢查是否為組合地址（如"臺北市中山區"）
                                /.*市.*區/.test(tag);
            
            return !isLocationTag;
        });
        
        console.log('移除地點標籤後的 lstQuery：', this.lstQuery);
    },

    // 處理區域變更（從子組件接收事件）
    handleAreaChange(values) {
      console.log('父組件接收到區域變更（完整路徑）：', values);
      
      if (!values || values.length === 0) {
        return;
      }
      
      // 先移除之前的地點選擇標籤
      this.removePreviousLocationTags();
      
      // 根據選擇層級決定顯示內容
      if (values.length === 1) {
        const area = values[0];

        if (area !== '全部') {
          this.lstQuery.push(area);
        }
      } else if (values.length === 2) {
        const area = values[0];    // 第一層：區域
        const city = values[1];    // 第二層：縣市
        
        console.log('加入查詢條件的城市名稱：', city);
        
        if (city !== '全部') {
          this.listQuery.comLoc = city;
          this.addQueryCondition('location', {
              city: city,
              district: ''
          }, `${city}`);
        }
      } else if (values.length === 3) {
        const area = values[0];      // 第一層：區域
        const city = values[1];      // 第二層：縣市  
        const district = values[2];  // 第三層：區域
        
        const txtAddress = `${city}${district}`;
        this.listQuery.comLoc = txtAddress;
        this.addQueryCondition('location', {
            city: city,
            district: district
        }, txtAddress);
        
        console.log('加入查詢條件的完整地址：', txtAddress);
      }
    },

    // 公司詳情相關方法
    async doShowCompanyDetail(data) {
      console.log('選中的公司資料:', data);
      const comid = data.UniComNm;
      const comname = data.Branch;
      this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名
      const url = `/companyDetail?comid=${comid}&comname=${comname}`;
      window.open(url, '_blank');
    },

    // 標籤雲相關方法
    async wordClickHandler(name, value) {
        
        console.log('wordClick', name, value);
        // this.keyword = name;
        

        this.$queryRecord(this, name, 'tag','總行標籤');  // 記錄點擊Tag	
            // 若點擊熱門標籤，則清除其他查詢條件，僅以該標籤作為查詢條件進行搜尋
            this.clearAllQueryConditions();            			
            this.addQueryCondition('preciseTag', {
                category: 'hq_category',
          display_name: name
        }, '', 'hq_category');				

            this.showTagCloud = false;
            await this.getList();
    },

    doTagsCloud() {
        this.loadHotTags();
        this.showTagCloud = true;
    },

    loadHotTags() {
    
        console.log("loadHotTags");
        this.$api.apihottags.getAllHotTags({isSys: true}).then((res)=>{
            console.log('取得熱門標籤成功:', res);
            this.hotTagsList = res.data;
            // 新增Weight屬性, 利用SortOrder來決定字體大小, 第1名最大, 依序遞減
            // 利用LN函數來平滑字體大小差異

                // 取出第11個, 因為前面10個是系統預設的熱門標籤, 
                const enabledHotTags = this.hotTagsList[10];
                console.log('第11個熱門標籤（用於控制按鈕顯示）:', enabledHotTags);
                if( enabledHotTags.TagName=="Y" ) {
                    this.btnHotTag = true;
                }
                else {
                    this.btnHotTag = false;
                }   
                console.log('熱門標籤顯示狀態:', this.btnHotTag);   
                this.hotTagsList = this.hotTagsList.slice(0,10);

            const maxWeight = 20; // 最大字體大小
            this.hotTagsList.forEach((tag, index) => {
                //tag.Weight = maxWeight - index; // 根據排序順序設定 Weight
                tag.Weight = Math.max(1, Math.round(Math.log(maxWeight - index + 1) )); // 使用對數函數平滑字體大小
            });
            console.log('熱門標籤列表:', this.hotTagsList);
        }, err => {
            handleError(err, '取得熱門標籤失敗');
        });
    },           
    
    // 搜尋條件相關方法
    comTypeClick(val) {
      this.listQuery.tx_Type = val.comType;
      this.lstQuery.push(val.comType);
      console.log("comTypeClick", val);
    },
    
    indusCodeClick() {
      console.log('行業代號:', this.industryCode);
      this.lstQuery.push(this.industryCode);
      this.industryCode = '';
      
      // 關閉下拉選單
      this.$refs.industryCodeDropdown.hide();
    },
    
    otherClick(val) {
      this.lstQuery.push(val);
    },
    
    // 更新其他條件處理
    otherChangeHandler(value) {
        const conditionMap = {
            '既有客戶': { type: 'isCustomer', checked: this.IsCustomer },
            '有發票': { type: 'isInvoice', checked: this.IsInvoice },
            '有進口': { type: 'isImport', checked: this.IsImport },
            '有出口': { type: 'isExport', checked: this.IsExport },
            '有工廠': { type: 'isFactory', checked: this.IsFactory }
        };
        
        const condition = conditionMap[value];
        if (condition) {
            if (condition.checked) {
                this.addQueryCondition(condition.type, true, value);
            } else {
                this.removeQueryCondition(value);
            }
        }
    },
    
    doClearTags() {
      // 保持與 ctm.vue 行為一致：清空 industryCode 選取，重置所有查詢條件，並清空選取區域
      this.selectedIndustryCode = [];
      this.clearAllQueryConditions();
      this.selectedAreaValue = [];

      // 額外清理 map 相關的標籤/列表狀態
      this.selectedTagsList = [];
      this.tags = [];

      // 移除地點相關顯示標籤（若需要）
      if (typeof this.removePreviousLocationTags === 'function') {
        this.removePreviousLocationTags();
      }
    },
    
    // 更新抽屜切換按鈕的位置
    updateToggleButtonPosition() {
      if (!this.drawerVisible || !this.$refs.toggleBtn) return;
      
      // 獲取抽屜元素
      const drawer = document.querySelector('.el-drawer.rtl');
      if (drawer) {
        // 獲取抽屜的左邊緣位置
        const drawerRect = drawer.getBoundingClientRect();
        const toggleBtn = this.$refs.toggleBtn;
        
        // 設置按鈕的位置，使其緊貼抽屜的左邊緣（減去 2px 的間隔，使其更緊貼）
        toggleBtn.style.left = (drawerRect.left - toggleBtn.offsetWidth - 2) + 'px';
        
        // 為了確保按鈕一直在正確位置，添加窗口調整大小的事件監聽
        if (!this._resizeListenerAdded) {
          window.addEventListener('resize', this.updateToggleButtonPosition);
          this._resizeListenerAdded = true;
        }
      }
    },
    
    // 更新資本額處理
    radClick(val) {
        console.log(val);
        
        // 如果選擇自訂區間，開啟對話框
        if (val === 'custom') {
            this.showCustomCapital = true;
            return;
        }
        
        const capInfo = this.capList.find(x => x.value === val);
        const displayText = capInfo.cap;
        
        // 先移除舊的資本額標籤
        this.capList.forEach(cap => {
            if (this.lstQuery.includes(cap.cap)) {
                this.removeQueryCondition(cap.cap);
            }
        });
        
        // 添加新的資本額條件
        this.addQueryCondition('capital', {
            start: capInfo.start,
            end: capInfo.end,
            range: displayText
        }, displayText);
        
        this.radCap = val;
    },
    
    // 確認自訂資本額區間
    confirmCustomCapital() {
        const start = parseFloat(this.customCapital.start);
        const end = parseFloat(this.customCapital.end);
        
        // 驗證輸入
        if (!start || !end) {
            notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束金額' });
            return;
        }
        
        if (start >= end) {
            notify({ type: 'warning', title: '警告', message: '起始金額必須小於結束金額' });
            return;
        }
        
        // 移除舊的資本額標籤（包括預設選項和之前的自訂區間）
        this.capList.forEach(cap => {
            if (this.lstQuery.includes(cap.cap)) {
                this.removeQueryCondition(cap.cap);
            }
        });
        
        // 移除之前的自訂區間標籤
        const customTags = this.lstQuery.filter(tag => tag.includes('萬~') && tag.includes('萬'));
        customTags.forEach(tag => {
            this.removeQueryCondition(tag);
        });
        
        // 建立顯示文字
        const displayText = `${start}萬~${end}萬`;
        
        // 添加新的資本額條件
        this.addQueryCondition('capital', {
            start: start,
            end: end,
            range: displayText
        }, displayText);
        
        // 清空輸入並關閉對話框
        this.customCapital.start = '';
        this.customCapital.end = '';
        this.showCustomCapital = false;
        
        notify({ type: 'success', title: '成功', message: `已設定資本額區間：${displayText}` });
    },

    // 更新設立日期處理
    yearClick(val) {
        // 如果選擇自訂區間，開啟對話框
        if (val === 'custom') {
            this.showCustomYear = true;
            return;
        }
        
        const yearInfo = this.yearList.find(x => x.value === val);
        const displayText = yearInfo.cap;
        
        // 計算實際的日期範圍
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - yearInfo.end;
        const endYear = currentYear - yearInfo.start;
        
        const startDate = `${startYear}-01-01`;
        const endDate = `${endYear}-12-31`;
        
        console.log('設立日期計算:', {
            currentYear,
            yearInfo,
            startYear,
            endYear,
            startDate,
            endDate
        });
        
        // 先移除舊的設立日期標籤
        this.yearList.forEach(year => {
            if (this.lstQuery.includes(year.cap)) {
                this.removeQueryCondition(year.cap);
            }
        });
        
        // 添加新的設立日期條件
        this.addQueryCondition('setupDate', {
            range: displayText,
            start: startDate,
            end: endDate,
            rangeValue: val
        }, displayText);
        
        this.yearCap = val;
    },
    
    // 確認自訂設立日期區間
    confirmCustomYear() {
        const start = parseFloat(this.customYear.start);
        const end = parseFloat(this.customYear.end);
        
        // 驗證輸入
        if (!start || !end) {
            notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束年限' });
            return;
        }
        
        if (start >= end) {
            notify({ type: 'warning', title: '警告', message: '起始年限必須小於結束年限' });
            return;
        }
        
        // 移除舊的設立日期標籤（包括預設選項和之前的自訂區間）
        this.yearList.forEach(year => {
            if (this.lstQuery.includes(year.cap)) {
                this.removeQueryCondition(year.cap);
            }
        });
        
        // 移除之前的自訂區間標籤
        const customTags = this.lstQuery.filter(tag => tag.includes('年~') && tag.includes('年'));
        customTags.forEach(tag => {
            this.removeQueryCondition(tag);
        });
        
        // 建立顯示文字
        const displayText = `${start}年~${end}年`;
        
        // 計算實際的日期範圍
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - end;
        const endYear = currentYear - start;
        const startDate = `${startYear}-01-01`;
        const endDate = `${endYear}-12-31`;
        
        // 添加新的設立日期條件
        this.addQueryCondition('setupDate', {
            range: displayText,
            start: startDate,
            end: endDate,
            rangeValue: 'custom'
        }, displayText);
        
        // 清空輸入並關閉對話框
        this.customYear.start = '';
        this.customYear.end = '';
        this.showCustomYear = false;
        
        notify({ type: 'success', title: '成功', message: `已設定設立日期區間：${displayText}` });
    },    
    

    
    // 更新標籤關閉處理
    handleClose(tag) {
        this.removeQueryCondition(tag);
    },
    

    // 處理左方抽屜的標籤點擊事件
    handleLeftDrawerTagClick(tagStr, typeFilter) {
      const tagName = typeof tagStr === 'string' ? tagStr : (tagStr?.name || '');
      const tagCategory = typeof tagStr === 'string' ? '' : (tagStr?.category || '');
      this.handleTagClick(tagName, tagCategory, typeFilter);
    },    
    
    
    // 地圖相關方法
    // 處理標籤按鈕點擊
    handleTagClick(itemOrTagStr, tagCategory = '', tagType = '標準標籤') {
      // 標籤字串點擊：參考 ctm.vue 的行為，導向標籤搜尋
      if (typeof itemOrTagStr === 'string') {
        console.log('標籤字串點擊：', itemOrTagStr, tagCategory, tagType);
        const tagStr = itemOrTagStr;
        if (!tagStr) {
          console.warn('handleTagClick: tagStr 為空');
          return;
        }
        this.$queryRecord(this, tagStr, 'tag', tagType);
        const baseUrl = window.location.origin;
        window.open(`${baseUrl}/ctm?keyword=${tagStr}&category=${tagCategory}&type=${tagType}`, '_blank');
        return;
      }

      // 公司項目點擊：即時向後端查詢最新標籤後開啟左側抽屜
      const item = itemOrTagStr;
      if (!item) {
        console.warn('handleTagClick: item 為空');
        return;
      }

      console.log('標籤按鈕點擊：', item.UniComNm, item.Branch);

      // 先用快取資料開啟 drawer，讓使用者立即看到畫面
      this.selectedCompanyTags = {
        company: item,
        br_tags: item.brTags || [],
        hq_tags: item.hqTags || []
      };
      this.splitStdTags = this.getStdTags();
      this.tagDrawerVisible = true;

      // 再即時呼叫 API 取得最新資料覆蓋（後端標籤更新可能有延遲）
      this.$store.dispatch('loadingHandler', true);
      this.$api.apies.search_bidmain({
        Page_Size: 1,
        Page_Num: 1,
        SearchText: [item.UniComNm]
      }).then(res => {
        const freshItem = res.data && res.data[0];
        if (freshItem) {
          const mapped = {
            UniComNm: freshItem.UniComNm,
            Branch: freshItem.ComName,
            ComLoc: freshItem.ComLoc,
            Tel: freshItem.Tel,
            Latitude: freshItem.Latitude,
            Longitude: freshItem.Longitude,
            Cap: freshItem.Cap,
            brTags: freshItem.br_category || [],
            hqTags: freshItem.hq_category || [],
            EstDate: freshItem.ApvDt,
            IndustryName: freshItem.IndusType,
            au_company_type: freshItem.au_company_type,
            au_is_import: freshItem.au_is_import,
            au_is_export: freshItem.au_is_export,
            au_is_factory: freshItem.au_is_factory,
            au_is_supplier: freshItem.au_is_supplier,
            au_is_china_fund: freshItem.au_is_china_fund,
            au_park_name: freshItem.au_park_name,
            au_is_existing_customer: freshItem.au_is_existing_customer,
            au_import_value: freshItem.au_import_value,
            au_export_value: freshItem.au_export_value,
            au_invest_area: freshItem.au_invest_area,
            au_is_invest_china: freshItem.au_is_invest_china,
            au_award_name: freshItem.au_award_name,
            au_certification: freshItem.au_certification,
            au_domain_name: freshItem.au_domain_name,
            au_alarm_item: freshItem.au_alarm_item,
            au_phone: freshItem.au_phone,
            au_mobile: freshItem.au_mobile,
            au_mail: freshItem.au_mail,
            au_industry_type: freshItem.au_industry_type,
            au_product: freshItem.au_product,
            au_brand_name: freshItem.au_brand_name
          };
          this.selectedCompanyTags = {
            company: mapped,
            br_tags: mapped.brTags,
            hq_tags: mapped.hqTags
          };
          this.splitStdTags = this.getStdTags();
          console.log('已更新為最新標籤資料:', mapped.brTags, mapped.hqTags);
        }
      }).catch(err => {
        console.warn('即時查詢標籤失敗，保留快取資料:', err);
      }).finally(() => {
        this.$store.dispatch('loadingHandler', false);
      });
    },
    
    // 處理明細按鈕點擊
    handleDetailClick(item) {
      if (!item) {
        console.warn('handleDetailClick: item 為空');
        return;
      }
      
      console.log('明細按鈕點擊：', item.UniComNm, item.Branch);
      notify({
        title: "查看明細",
        message: `您點擊了 ${item.Branch} 的明細按鈕`,
        type: "info"
      });
      
      // 這裡可以添加跳轉到明細頁面的邏輯
      // 或者在右側面板顯示詳細信息
      
      // 例如：跳轉到詳情頁
      // this.$router.push({
      //   path: '/ctmDetail',
      //   query: { id: item.UniComNm }
      // });
    },
    
    doshowMap(row, index) {
      // 0. 當無經緯度資料時，顯示提示訊息並返回
      if (!row.Latitude || !row.Longitude) {
        notify({
          title: "無經緯度資料",
          message: `公司 ${row.Branch} 無經緯度資料，無法在地圖上顯示位置。`,
          type: "warning"
        });
        return;
      }
      
      console.log('顯示地圖位置：', row.Branch, '序號：', index, row);

      this.selectedPOI = row; // 儲存選中的 POI 資訊
      
      // 1. 移動地圖到該公司位置
      if (this.mapObj && row.Latitude && row.Longitude) {
        // 設定地圖中心到該公司位置
        this.mapObj.setView([row.Latitude, row.Longitude], 15); // 放大層級設為15，可以調整
        
        console.log('row==', row);
        // 創建彈出視窗，加上序號
        const popMessage = `
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; min-width: 320px;">
            <h3 style="margin: 0;">${index}. ${row.Branch}</h3>
            <div style="display: flex; gap: 8px;">
              <button 
                onclick="window.handleFindNearbyCustomers('${row.Branch}', ${row.Latitude}, ${row.Longitude})" 
                style="
                  border-radius: 4px; background: #67C23A; 
                  border: none; color: white; cursor: pointer; display: flex; 
                  align-items: center; justify-content: center; font-size: 12px;
                  padding: 2px 8px;
                "
                title="尋找${row.Branch}附近的潛在客戶"
              >
                @
              </button>
              <button 
                onclick="window.handleAddPotentialCustomerClick('${row.UniComNm}', '${row.Branch}', ${row.Latitude}, ${row.Longitude})" 
                style="
                  width: 24px; height: 24px; border-radius: 50%; background: #409EFF; 
                  border: none; color: white; cursor: pointer; display: flex; 
                  align-items: center; justify-content: center; font-size: 12px;
                "
                title="新增潛在客戶"
              >
                #
              </button>
              <button 
                onclick="window.handleOpenAddTagDialog('${row.UniComNm}', '${row.Branch}')" 
                style="
                  width: 24px; height: 24px; border-radius: 50%; background: #E6A23C; 
                  border: none; color: white; cursor: pointer; display: flex; 
                  align-items: center; justify-content: center; font-size: 12px;
                "
                title="新增標籤"
              >
                T
              </button>
            </div>
          </div>
          ${row.Cap? '<br>資本額：' + this.capFormat(row.Cap) : ''}${row.ComLoc? '<br>地址：' + row.ComLoc : ''}${row.Tel ? '<br>電話：' + row.Tel : ''}${row.RepName ? '<br>負責人：'+ row.RepName : '' }
        `;
        
        const popMessage1 = `
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; min-width: 320px;">
            <h3 style="margin: 0;">${index}. ${row.Branch}</h3>
            <div style="display: flex; gap: 8px;">
              <button 
                onclick="window.handleFindNearbyCustomers('${row.Branch}', ${row.Latitude}, ${row.Longitude})" 
                style="
                  border-radius: 4px; background: #67C23A; 
                  border: none; color: white; cursor: pointer; display: flex; 
                  align-items: center; justify-content: center; font-size: 12px;
                  padding: 2px 8px;
                "
                title="尋找${row.Branch}附近的潛在客戶"
              >
                @
              </button>
            </div>
          </div>
          ${row.Cap? '<br>資本額：' + this.capFormat(row.Cap) : ''}${row.ComLoc? '<br>地址：' + row.ComLoc : ''}${row.Tel ? '<br>電話：' + row.Tel : ''}${row.RepName ? '<br>負責人：'+ row.RepName : '' }
        `;
                
        // 使用預載入的序號圖標
        let numberIcon;
        
        // 檢查是否有預載入的圖標可用
        if (index <= 10 && this.mapConfig.numberIcons[index]) {
          console.log(`使用預載入的圖標 ${index}.png`);
          numberIcon = this.mapConfig.numberIcons[index];
        } else {
          console.warn(`找不到預載入的圖標 ${index}，使用預設圖標`);
          numberIcon = this.mapConfig.orangeIcon; // 使用預設的橙色圖標
        }
        
        // 先清除任何可能存在的臨時標記
        if (this.activeMarker) {
          this.mapObj.removeLayer(this.activeMarker);
        }
        
        // 創建新的臨時標記
        this.activeMarker = L.marker([row.Latitude, row.Longitude], { 
          icon: numberIcon, // 使用已創建的 numberIcon
          zIndexOffset: 1000 // 確保這個標記在最上層
        }).addTo(this.mapObj);
        
        

        if( this.btnAdvFuncVisible) { // 
          
          // 綁定彈出視窗並打開，設定最大寬度和自動調整選項
          this.activeMarker.bindPopup(popMessage, {
            maxWidth: 400,  // 增加最大寬度
            minWidth: 320,  // 設置最小寬度
            className: 'custom-popup', // 使用自定義樣式
            autoPan: true     // 自動移動地圖使彈出窗口完全可見
          }).openPopup();
        } else { // DO, APA, AP , 無權.
          
          // 綁定彈出視窗並打開，設定最大寬度和自動調整選項
          this.activeMarker.bindPopup(popMessage1, {
            maxWidth: 400,  // 增加最大寬度
            minWidth: 320,  // 設置最小寬度
            className: 'custom-popup', // 使用自定義樣式
            autoPan: true     // 自動移動地圖使彈出窗口完全可見
          }).openPopup();          
        }


        
        // 使用淡入動畫效果平滑過渡
        this.mapObj.flyTo([row.Latitude, row.Longitude], 15, {
          duration: 1.5, // 動畫時間 1.5 秒
          easeLinearity: 0.5
        });
      }

      // 🔥 再次確保抽屜開啟（防止動畫過程中被關閉）
      this.$nextTick(() => {
        this.drawerVisible = true;
      });      
      
      // 2. 仍然保留開啟新視窗的功能，但改為可選參數
      if (this.$route.query.openNewWindow === 'true') {
        const url = `/ctmMapCom?branch=${row.Branch}&lat=${row.Latitude}&lng=${row.Longitude}`;
        window.open(url, '_blank');
      }
    },
    
    capFormat: function(num) {
        if( num ===null) 
            return "";
        else  {
            if (num >= 100000000) {
                return (num / 100000000).toFixed(0)  + ' 億';
            } else {
                return (num / 10000).toFixed(0) + ' 萬';
            }
        }
    },

    doSearch() {
      
      // 先保留輸入的keyword, 因為this.removeQueryCondition會改變this.keyword
      const newKeyword = this.keyword.trim();
      
      // 重置翻頁
      this.listQuery.Page_Num = 1;

      // 先移除舊的 keyword 條件（避免重複累積）, 因為 keyword 只能有一個
      for (const [tag, mapping] of Array.from(this.queryConditionMap.entries())) {
        if (mapping && mapping.type === 'keyword') {
          this.removeQueryCondition(tag);
        }
      }
      
      // 新增查詢條件（只在有關鍵字時才加入）
      if (newKeyword && newKeyword.length > 0) {
        console.log('3加入關鍵字查詢條件:', newKeyword);
        this.addQueryCondition('keyword', newKeyword, newKeyword);
      }

      if( this.keyword && this.keyword.trim() !== '' )
          this.$queryRecord(this, newKeyword, 'keyword');  // 記錄搜尋關鍵字      
      // 執行 getList 方法
      this.getList();
      
      // 如果有查詢詞或地區條件，才自動開啟右方抽屜
      if (newKeyword.length > 0) {
        this.drawerVisible = true;
      }
    },
    
    async getList() {
      // 初始化地圖
      if (!this.mapInitialized) {
        this.initialMap();
        this.mapInitialized = true;
      }
      

      
      if( true) {
          let qry = { 
            Page_Size: this.listQuery.Page_Size, 
            Page_Num: this.listQuery.Page_Num 
          };
          console.log('初始查詢參數:', this.queryConditions);

          // 處理地區條件
          if( this.queryConditions.location.city && this.queryConditions.location.city !== '全部' ) {
              qry.City = this.queryConditions.location.city;
          }
          if( this.queryConditions.location.district && this.queryConditions.location.district !== '' ) {
              qry.District = this.queryConditions.location.district;
          }          

          // 處理關鍵詞查詢
          if (this.queryConditions.keyword?.length > 0) {
            // 先用空格切開查詢詞，支援多關鍵字查詢, 並轉成list 
            const querykeysList = this.queryConditions.keyword.trim().split(/\s+/);            
            qry.SearchText = querykeysList;
          }

          // 處理公司狀況
          if (this.queryConditions.companyStatus.length > 0) {
            if (this.queryConditions.companyStatus === '營業中') {
                qry.DataStatus = ['new','modify'];
            } else if (this.queryConditions.companyStatus === '非營業中') {
                qry.DataStatus = ['delete'];
            }
            // qry.DataStatus = [this.queryConditions.companyStatus];
          }
          
          // 處理公司類別
          if (this.queryConditions.companyType.length > 0) {
            qry.AuComType = this.queryConditions.companyType;
          }
          // 處理組織別
          if (this.queryConditions.orgType.length > 0) {
            qry.ComType = this.queryConditions.orgType;
          }
          // 處理即有客戶
          if (this.queryConditions.isCustomer) {
            qry.IsExistingCustomer = 'Y';
          }
          // 處理有發票
          if (this.queryConditions.isInvoice) {
            qry.HasInvoice = 'Y';
          }
          // 處理有進口
          if (this.queryConditions.isImport) {
            qry.HasImport = 'Y';
          }
          // 處理有出口
          if (this.queryConditions.isExport) {
            qry.HasExport = 'Y';
          }
          // 處理有工廠
          if (this.queryConditions.isFactory) {
            qry.HasFactory = 'Y';
          }
          // 處理資本額
          if (this.queryConditions.capital.range) {
            qry.CapMin = this.queryConditions.capital.start * 10000; // 以萬元為單位
            qry.CapMax = this.queryConditions.capital.end * 10000; // 以萬元為單位
          }
          // 處理設立日期
          if (this.queryConditions.setupDate.range) {
            qry.Start_Date = this.queryConditions.setupDate.start;
            qry.End_Date = this.queryConditions.setupDate.end;
          }
          // 處理行業代號
          if (this.queryConditions.industryCode && this.queryConditions.industryCode.length > 0) {
            qry.IndusNm = this.queryConditions.industryCode; 
          }

          // 處理精確標籤查詢
          if (this.queryConditions.preciseTags && this.queryConditions.preciseTags.length > 0) {
              qry.PreciseTags = this.queryConditions.preciseTags.map(tagItem => ({
                      category: tagItem.category,
                      display_name: tagItem.display_name || tagItem.name
              }));
          }          

          // 處理經緯度範圍查詢
          if( this.queryConditions.geolocation.Distance.length >0 &&
              this.queryConditions.geolocation.Latitude &&
              this.queryConditions.geolocation.Longitude ) {
              
              qry.Distance = this.queryConditions.geolocation.Distance;
              qry.Latitude = this.queryConditions.geolocation.Latitude;
              qry.Longitude = this.queryConditions.geolocation.Longitude;
          }


          this.$store.dispatch("loadingHandler", true);
          try {

            console.log('查詢參數:', qry);
            const res = await this.$api.apies.search_bidmain(qry);
            let result = res.data;
            console.log('查詢結果:', result);
            this.totalLists = parseInt(res.total);
            this.tabledata = result.map(item => {              
              return {
                UniComNm: item.UniComNm,                
                Branch: item.ComName,
                ComLoc: item.ComLoc,
                Tel: item.Tel,
                Latitude: item.Latitude,
                Longitude: item.Longitude,
                Cap: item.Cap,
                brTags: item.br_category || [],
                hqTags: item.hq_category || [],
                EstDate: item.ApvDt,
                IndustryName: item.IndusType,
                au_company_type: item.au_company_type,
                au_is_import: item.au_is_import,
                au_is_export: item.au_is_export,
                au_is_factory: item.au_is_factory,
                au_is_supplier: item.au_is_supplier,
                au_is_china_fund: item.au_is_china_fund,
                au_park_name: item.au_park_name,
                au_is_existing_customer: item.au_is_existing_customer,
                au_import_value: item.au_import_value,
                au_export_value: item.au_export_value,
                au_invest_area: item.au_invest_area,
                au_is_invest_china: item.au_is_invest_china,
                au_award_name: item.au_award_name,
                au_certification: item.au_certification,
                au_domain_name: item.au_domain_name,
                au_alarm_item: item.au_alarm_item,
                au_phone: item.au_phone,
                au_mobile: item.au_mobile,
                au_mail: item.au_mail,
                au_industry_type: item.au_industry_type,
                au_product: item.au_product,
                au_brand_name: item.au_brand_name
              };
            });
            console.log('查詢結果:', this.tabledata);

            // 只要有目前選中公司，就同步到最新查詢結果（不依賴 drawer 是否開啟）
            if (this.selectedCompanyTags.company?.UniComNm) {
              const currentUniComNm = this.selectedCompanyTags.company.UniComNm;
              const refreshedCompany = this.tabledata.find(
                (row) => row.UniComNm === currentUniComNm
              );
              if (refreshedCompany) {
                this.selectedCompanyTags = {
                  company: refreshedCompany,
                  br_tags: refreshedCompany.brTags || [],
                  hq_tags: refreshedCompany.hqTags || []
                };
                this.splitStdTags = this.getStdTags();
              }
            }
            
            if (result.length > 0 && result[0].Latitude && result[0].Longitude) {
              this.latitude = result[0].Latitude;
              this.longitude = result[0].Longitude;
              this.zoomDegree = 13;
            }
            this.groupMap();
          } catch (err) {
            handleError(err, '查詢客戶資料失敗');
            
            // 即使 API 失敗，也要確保地圖顯示
            if (this.mapInitialized) {
              this.groupMap();
            }
          }
          this.$store.dispatch("loadingHandler", false);
          
          // 如果不是初始載入，則自動開啟抽屜
          if (this.mapInitialized) {
            this.drawerVisible = true;
          }

      }
    },
    
    async pageChange(val) {
      this.listQuery.Page_Num = val;
      await this.getList();
      // 確保翻頁後抽屜保持開啟
      this.drawerVisible = true;
    },
    
    // 地圖初始化
    initialMap() {
      // 如果地圖已經初始化，則不需要重新初始化
      if (this.mapInitialized && this.mapObj) {
        console.log('地圖已經初始化，跳過initialMap');
        // 確保地圖視圖正確
        this.mapObj.setView([this.latitude, this.longitude], this.zoomDegree);
        return;
      }
      
      // 創建標準的橙色圖標，使用絕對路徑
      const defaultIcon = new L.Icon({
        iconUrl: '/markericons/marker-icon-2x-orange.png',
        shadowUrl: '/markericons/marker-shadow.png',
        iconSize: [20, 33], // 稍微減小圖標大小，保持比例
        iconAnchor: [10, 33], // 調整錨點使其保持在圖標底部中央
        popupAnchor: [1, -30],
        shadowSize: [33, 33]
      });
      
      // 保存到 mapConfig 中以便後續使用
      this.mapConfig.orangeIcon = defaultIcon;

      // 創建紅色圖標供 exact 模式使用
      const redIcon = new L.Icon({
        iconUrl: '/markericons/marker-icon-2x-red.png',
        shadowUrl: '/markericons/marker-shadow.png',
        iconSize: [20, 33],
        iconAnchor: [10, 33],
        popupAnchor: [1, -30],
        shadowSize: [33, 33]
      });
      this.mapConfig.redIcon = redIcon;
      
      // 確保地圖容器大小計算正確
      setTimeout(() => {
        const mapElement = document.getElementById('map');
        // console.log('Map element size:', mapElement.offsetWidth, mapElement.offsetHeight);
      }, 100);
      
      // 初始化地圖, 右鍵的選項內容
      const map = L.map('map', {
        attributionControl: false,
        contextmenu: true,
        contextmenuWidth: 180,
        contextmenuItems: [
          {
            text: '尋找?公里內的潛在客戶',
            callback: (e) => {
              this.onFindNearbyCustomers(e);
            }
          }
          // ,
          // {
          //   separator: true
          // },
          // {
          //   text: '新增潛在客戶',
          //   callback: (e) => {
          //     this.onAddPotentialCustomer(e, map, defaultIcon);
          //   }
          // }
        ]
      }).setView([this.latitude, this.longitude], this.mapConfig.defaultZoom);
      
      L.tileLayer(this.mapConfig.tileLayerUrl, {
        minZoom: this.mapConfig.minZoom,
        maxZoom: this.mapConfig.maxZoom,
        attribution: ''
      }).addTo(map);
      
      const markers = new L.markerClusterGroup();
      map.addLayer(markers);

      // 設定初始的地圖中心點和縮放級別
      map.setView([this.latitude, this.longitude], this.zoomDegree);

      // console.log('目前搜尋地點:', this.listQuery.comLoc);
      
      this.mapObj = map;
      
      // 確保地圖正確渲染
      setTimeout(() => {
        if (this.mapObj) {
          this.mapObj.invalidateSize();
          // console.log('地圖大小已重新計算');
          this.mapInitialized = true; // 標記地圖已初始化
        }
      }, 300);
    },
    
    // 右鍵選單相關方法
    onFindNearbyCustomers(e) {
      this.showDistanceDialog = true;
      this.distanceLatLng = e.latlng; // 儲存點擊座標
      if (this.mapObj) this.mapObj.closePopup();
    },
    
    // 新增潛在客戶
    onAddPotentialCustomer(e, map, icon) {
      if( this.btnAdvFuncVisible === false ) {

          return;
      }

      // 檢查是否已選中客戶
      if( ! this.selectedPOI || !this.selectedPOI.UniComNm) {
          notify({
            title: "尚未選中客戶",
            message: `目前尚未選中客戶，請先選擇客戶後再新增潛在客戶。`,
            type: "warning"
          });
          return;
      }

      console.log('新增潛在客戶資訊：', this.selectedPOI);

      this.addCustomer.ComName = this.selectedPOI.Branch;
      this.addCustomer.UniComNm = this.selectedPOI.UniComNm;      

      this.showCustomer = true;

      // L.marker(e.latlng, { icon: icon }).addTo(map)
      //   .bindPopup('新潛在客戶').openPopup();
    },


    // 地圖更新
    groupMap() {
      // 創建默認的橙色圖標，使用絕對路徑
      const defaultIcon = new L.Icon({
        iconUrl: '/markericons/marker-icon-2x-orange.png',
        shadowUrl: '/markericons/marker-shadow.png',
        iconSize: [20, 33], // 稍微減小圖標大小，保持比例
        iconAnchor: [10, 33], // 調整錨點使其保持在圖標底部中央
        popupAnchor: [1, -30],
        shadowSize: [33, 33]
      });
      
      this.mapObj.remove();
      
      this.mapObj = L.map('map', { 
        attributionControl: false,
        contextmenu: true,
        contextmenuWidth: 180,
        contextmenuItems: [
          {
            text: '尋找?公里內的潛在客戶',
            callback: (e) => {
              this.onFindNearbyCustomers(e);
            }
          }
        // ,
        //   {
        //     separator: true
        //   },
        //   {
        //     text: '新增潛在客戶',
        //     callback: (e) => {
        //       this.onAddPotentialCustomer(e, this.mapObj, defaultIcon);
        //     }
        //   }
        ]
      }).setView([this.latitude, this.longitude], this.zoomDegree);
      
      L.tileLayer(process.env.VUE_APP_TILE_LAYER_URL + '/data/v3/{z}/{x}/{y}.jpg', {
        minZoom: 10,
        maxZoom: 16,
        attribution: ''
      }).addTo(this.mapObj);
      
      var markers = new L.markerClusterGroup().addTo(this.mapObj);
      
      // 計算當前頁面應該顯示的項目數量
      const pageSize = this.listQuery.Page_Size || 10; // 默認每頁10條
      const currentPage = this.listQuery.Page_Num || 1; // 默認第1頁
      const startIndex = 0; // 從第一條開始
      const endIndex = Math.min(this.tabledata.length, pageSize); // 只顯示當前頁面的項目
      
      // 只為當前頁面上顯示的項目創建標記
      for (var i = startIndex; i < endIndex; i++) {
        var lat = this.tabledata[i].Latitude;
        var lng = this.tabledata[i].Longitude;
        var branch = this.tabledata[i].Branch;
        var RepName = this.tabledata[i].RepName;
        var location = this.tabledata[i].Location;
        var index = i + 1; // 序號從1開始
        
        // 顯示序號在彈出視窗中        
        const row = this.tabledata[i];
        
        // 創建彈出視窗，加上序號
        const popMessage = `
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; min-width: 320px;">
            <h3 style="margin: 0;">${index}. ${row.Branch}</h3>
            <button 
              onclick="window.handleFindNearbyCustomers('${row.Branch}', ${row.Latitude}, ${row.Longitude})" 
              style="
                border-radius: 4px; background: #67C23A; 
                border: none; color: white; cursor: pointer; display: flex; 
                align-items: center; justify-content: center; font-size: 12px;
                padding: 2px 8px;
              "
              title="尋找${row.Branch}附近的潛在客戶"
            >
              @
            </button>            
            <button 
              onclick="window.handleAddPotentialCustomerClick('${row.UniComNm}', '${row.Branch}', ${row.Latitude}, ${row.Longitude})" 
              style="
                width: 24px; height: 24px; border-radius: 50%; background: #409EFF; 
                border: none; color: white; cursor: pointer; display: flex; 
                align-items: center; justify-content: center; font-size: 12px;
              "
              title="新增潛在客戶"
            >
              #
            </button>
            <button 
              onclick="window.handleOpenAddTagDialog('${row.UniComNm}', '${row.Branch}')" 
              style="
                width: 24px; height: 24px; border-radius: 50%; background: #E6A23C; 
                border: none; color: white; cursor: pointer; display: flex; 
                align-items: center; justify-content: center; font-size: 12px;
              "
              title="新增標籤"
            >
              T
            </button>            
          </div>
          ${row.Cap? '<br>資本額：' + this.capFormat(row.Cap) : ''}${row.ComLoc? '<br>地址：' + row.ComLoc : ''}${row.Tel ? '<br>電話：' + row.Tel : ''}${row.RepName ? '<br>負責人：'+ row.RepName : '' }
        `;        
        
        const popMessage1 = `
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; min-width: 320px;">
            <h3 style="margin: 0;">${index}. ${row.Branch}</h3>
            <button 
              onclick="window.handleFindNearbyCustomers('${row.Branch}', ${row.Latitude}, ${row.Longitude})" 
              style="
                border-radius: 4px; background: #67C23A; 
                border: none; color: white; cursor: pointer; display: flex; 
                align-items: center; justify-content: center; font-size: 12px;
                padding: 2px 8px;
              "
              title="尋找${row.Branch}附近的潛在客戶"
            >
              @
            </button>
          </div>
          ${row.Cap? '<br>資本額：' + this.capFormat(row.Cap) : ''}${row.ComLoc? '<br>地址：' + row.ComLoc : ''}${row.Tel ? '<br>電話：' + row.Tel : ''}${row.RepName ? '<br>負責人：'+ row.RepName : '' }
        `;        
                
        // 使用預載入的序號圖標
        let numberIcon;
        
        // 檢查是否有預載入的圖標可用
        if (index <= 10 && this.mapConfig.numberIcons[index]) {
          // console.log(`群組地圖: 使用預載入的圖標 ${index}.png`);
          numberIcon = this.mapConfig.numberIcons[index];
        } else {
          // console.warn(`群組地圖: 找不到預載入的圖標 ${index}，使用預設圖標`);
          numberIcon = defaultIcon; // 使用預設的橙色圖標
        }
        
        // 添加標記到地圖上
        if( this.btnAdvFuncVisible) {
          markers.addLayer(L.marker([lat, lng], { icon: numberIcon }).bindPopup(popMessage));
        } else {
          markers.addLayer(L.marker([lat, lng], { icon: numberIcon }).bindPopup(popMessage1));
        }
        // markers.addLayer(L.marker([lat, lng], { icon: numberIcon }).bindPopup(popMessage));
      }
      
      // 確保地圖正確渲染
      setTimeout(() => {
        if (this.mapObj) {
          this.mapObj.invalidateSize();
          console.log('groupMap: 地圖大小已重新計算');
        }
      }, 300);
    },
    
    // 距離搜尋對話框相關方法
    async confirmDistanceSearch() {
      // 檢查是否有有效的座標
      if (!this.distanceLatLng || !this.distanceLatLng.lat || !this.distanceLatLng.lng) {
        notify({
          title: "錯誤",
          message: "無法取得搜尋座標，請重新選擇位置",
          type: "error"
        });
        this.showDistanceDialog = false;
        return;
      }
      
      // 這裡可根據 this.searchDistance 及 this.distanceLatLng 執行搜尋
      notify({
        title: "距離搜尋",
        message: `正在搜尋 ${this.searchDistance} 公里內的潛在客戶...`,
        type: "info"
      });
      
      // 清除其他的搜尋條件
      this.clearAllQueryConditions(); 
      // 需要把this.selectedAreaValue 清空，避免與地理位置搜尋條件衝突
      this.selectedAreaValue = ['全部', '全部'];  // 清空區域選擇（非常重要！）

      this.queryConditions.geolocation = {
        Latitude: this.distanceLatLng.lat,
        Longitude: this.distanceLatLng.lng,
        Distance: this.searchDistance + "km"
      };

      // 加入地理位置的搜尋條件，顯示在查詢條件區塊中
      this.addQueryCondition('geolocation', 
        this.queryConditions.geolocation, 
        `距離${this.queryConditions.geolocation.Distance} 內`);

      // 加上資本額超過1000萬的條件   單位: 萬元
      this.addQueryCondition('capital', {
          start: 1001,
          end: 9999999,
          range: "1千萬(不含)以上"
      }, "1千萬(不含)以上");      
      await this.getList();

      this.showDistanceDialog = false;
    },
    
    cancelDistanceSearch() {
      this.showDistanceDialog = false;
    },

    // 處理定位按鈕點擊
    async handleLocationClick() {
      if (this.isLocating) {
        return; // 如果正在定位中，忽略點擊
      }

      try {
        this.isLocating = true;
        await this.getUserLocation();
      } catch (error) {
        console.error('定位失敗:', error);
      } finally {
        this.isLocating = false;
      }
    },
    
    // 獲取使用者位置（使用 Promise 包裝）
    getUserLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          const errorMsg = "您的瀏覽器不支援地理位置功能";
          notify({
            title: "瀏覽器不支援",
            message: errorMsg,
            type: "error"
          });
          reject(new Error(errorMsg));
          return;
        }

        // 先嘗試快速定位（較低精度）
        const quickOptions = {
          enableHighAccuracy: false,
          timeout: 8000,
          maximumAge: 60000 // 允許使用1分鐘內的緩存位置
        };

        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.handleLocationSuccess(position);
            resolve(position);
          },
          (error) => {
            console.log('快速定位失敗，嘗試高精度定位...', error);
            // 如果快速定位失敗，嘗試高精度定位
            this.tryHighAccuracyLocation()
              .then(resolve)
              .catch(reject);
          },
          quickOptions
        );
      });
    },

    // 嘗試高精度定位
    tryHighAccuracyLocation() {
      return new Promise((resolve, reject) => {
        const highAccuracyOptions = {
          enableHighAccuracy: true,
          timeout: 15000, // 增加到15秒
          maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.handleLocationSuccess(position);
            resolve(position);
          },
          (error) => {
            this.handleLocationError(error);
            reject(error);
          },
          highAccuracyOptions
        );
      });
    },

    // 處理定位成功
    handleLocationSuccess(position) {
      // 成功獲取位置
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      
      // 更新地圖視圖到使用者位置
      if (this.mapObj) {
        this.mapObj.setView([this.latitude, this.longitude], 14);
        
        // 添加使用者位置標記
        const userIcon = new L.Icon({
          iconUrl: '/markericons/marker-icon-2x-blue.png',
          shadowUrl: '/markericons/marker-shadow.png',
          iconSize: [20, 33], // 稍微減小圖標大小，保持比例
          iconAnchor: [10, 33], // 調整錨點使其保持在圖標底部中央
          popupAnchor: [1, -30],
          shadowSize: [33, 33]
        });
        
        L.marker([this.latitude, this.longitude], { icon: userIcon })
          .addTo(this.mapObj)
          .bindPopup('您的位置')
          .openPopup();
      }
      
      // 優化後的通知訊息
      notify({
        title: "位置獲取成功",
        message: `已定位至您的當前位置 (${position.coords.latitude.toFixed(4)}, ${position.coords.longitude.toFixed(4)})`,
        type: "success"
      });
    },

    // 處理定位失敗
    handleLocationError(error) {
      let errorMsg = "無法獲取您的位置";
      let notificationType = "warning";
      
      switch (error.code) {
        case error.PERMISSION_DENIED:
          errorMsg = "位置服務已被拒絕，請在瀏覽器設定中允許位置存取";
          notificationType = "error";
          break;
        case error.POSITION_UNAVAILABLE:
          errorMsg = "位置信息不可用，請檢查GPS是否開啟";
          break;
        case error.TIMEOUT:
          errorMsg = "獲取位置超時，請確保GPS信號良好並重試";
          break;
        default:
          errorMsg = `定位失敗：${error.message || '未知錯誤'}`;
      }
      
      notify({
        title: "位置獲取失敗",
        message: errorMsg,
        type: notificationType
      });
    },
    
    // 處理窗口大小變化
    handleResize() {
      // 確保地圖容器存在
      if (this.mapObj) {
        // 通知 Leaflet 地圖容器大小已變化
        this.mapObj.invalidateSize();
        console.log('重新計算地圖大小');
      }
    },
    
    // 處理新增潛在客戶按鈕點擊（供 popup 中的按鈕使用）
    handleFindNearbyCustomers(branch, latitude, longitude) {
      console.log('尋找公司內的潛在客戶:', branch, latitude, longitude);
      
      // 設置距離搜尋的座標
      this.distanceLatLng = {
        lat: latitude,
        lng: longitude
      };
      
      // 設置當前選擇的公司資訊
      this.currentCompany = {
        branch,
        latitude,
        longitude
      };
      
      // 顯示距離對話框
      this.showDistanceDialog = true;
    },
    
    handleAddPotentialCustomerClick(uniComNm, branch, latitude, longitude) {
      console.log('新增潛在客戶按鈕點擊:', { uniComNm, branch, latitude, longitude });
      
      // notify({
      //   title: "新增潛在客戶",
      //   message: `正在為 ${branch} 新增潛在客戶`,
      //   type: "success"
      // });
      
      if( this.selectedPOI ) {
        console.log('新增潛在客戶資訊：', this.selectedPOI);
        this.addCustomer.ComName = this.selectedPOI.Branch;
        this.addCustomer.UniComNm = this.selectedPOI.UniComNm;
      }
      else {
        this.addCustomer = {
                ComName: branch,
                UniComNm: uniComNm
              };
      }

      this.showCustomer = true;
    },

    loadProjectNameList() {    
        if( this.btnAdvFuncVisible== false )
            return;
        const qry = {
            "Page_Num": 1,
            "Page_Size": 20
            
        };
        
        console.log("載入專案名稱參數",qry);    
        this.$api.apipocxpj.pocxpj_search(qry).then(response => {
            console.log("專案名稱列表",response.data);
            this.ProjectNameList = response.data;
        }).catch(error => {
            notify({
                title: "錯誤",
                message: "獲取專案名稱失敗，請稍後再試",
                type: "error"
            });                
        });
    },        

    // 由API中, 取得已儲存的搜尋條件列表
    loadSaveSearchfromAPI() {
        // console.log("loadSaveSearch from API");
        const qry={
          isSys: true
        }
        this.$api.apisc.sc_search(qry).then((res)=>{
            // console.log('取得已儲存的搜尋條件列表成功:', res);
            // 轉換成 saveSearchList 格式
            this.saveSearchList = res.data.map(item => {
                // 先處理 query 的轉換
                const queryTags = item.Parameters ? Object.entries(item.Parameters).map(([key, value]) => {
                    // 根據 key 轉換成顯示標籤
                    switch(key) {
                        case 'keyword':
                            return value || null;
                        case 'companyStatus':
                            return value || null;
                        case 'companyType':
                            return value || null; // 假設 value 是陣列
                        case 'orgType':
                            return value || null; // 假設 value 是陣列
                        case 'isCustomer':
                            return value ? '既有客戶' : null;
                        case 'isInvoice':
                            return value ? '開立發票' : null;
                        case 'isImport':
                            return value ? '進口' : null;
                        case 'isExport':
                            return value ? '出口' : null;
                        case 'isFactory':
                            return value ? '工廠' : null;
                        case 'capital':
                            return (value.start && value.end) ? `資本額: ${value.start} - ${value.end}` : null;
                        case 'setupDate':
                            return (value.start && value.end) ? `設立日期: ${value.start} - ${value.end}` : null;
                        case 'industryCode':
                            return value || null;
                        case 'preciseTags':
                          if (Array.isArray(value)) {
                            return value.map(tagItem => {
                              const displayName = tagItem?.display_name || tagItem?.name;
                              if (!tagItem || !displayName) return null;
                              const title = this.getPreciseTagTitle(tagItem.category);
                              return `${title}:${displayName}`;
                            }).filter(x => x !== null);
                          }
                          return null;
                        case 'location':
                            return (value.city || value.district) ? `${value.city}${value.district}` : null;
                        default:
                            return null;
                    }
                }).flat().filter(x => x !== null) : [];
                
                return {
                    name: item.ConditionName,
                    desc: item.Description || '',
                    query: queryTags,
                    conditions: item.Parameters || {},
                    mapping: item.Mapping || []
                };
            });
            // console.log('轉換後的儲存搜尋條件列表:', this.saveSearchList);
        }, err => {
            handleError(err, '取得已儲存的搜尋條件列表失敗');
        });
    },    
    
    handleSaveSearch() {
        // 檢查 lstQuery 是否有內容
        if (this.lstQuery.length === 0) {
            this.$message({
                message: '請先加入查詢條件後再儲存',
                type: 'warning'
            });
            return;
        }
        this.showSaveSearch = true;
    },

    // 儲存搜尋條件
    saveSearch() {
        console.log("saveSearch");
        // 儲存搜尋條件時
        let qry = {
            name: this.ssName,
            desc: this.ssDesc,
            displayTags: [...this.lstQuery],           // 顯示用的標籤
            conditions: { ...this.queryConditions },   // 結構化的查詢條件
            mapping: Array.from(this.queryConditionMap.entries())  // 映射關係
        };
        // console.log('已儲存搜尋條件:', qry);
        // console.log('目前儲存的搜尋條件列表:', this.saveSearchList);
        // console.log('queryConditions:', this.queryConditions);

        // 呼叫API儲存到後端
        this.$api.apisc.sc_create({
                "ConditionName": this.ssName,
                "Parameters": this.queryConditions                    
        }).then((res)=>{
            console.log('儲存搜尋條件到後端成功:', res);
            // this.saveSearchList.push(qry);
            notify({ type: 'success', title: '成功', message: `已成功儲存搜尋條件: ${this.ssName}` });

            // 重新載入已儲存的搜尋條件列表
            this.loadSaveSearchfromAPI();
            
            this.showSaveSearch = false;
        }, err => {
            handleError(err, '儲存搜尋條件到後端失敗');
        });
    },

    changeSaveSearch() {
        console.log("changeSaveSearch");
        this.lstLoadQuery = [];
        // 將selSaveSearch的query, 複製到lstQuery
        let qry = this.saveSearchList.find(x=>x.name==this.selSaveSearch);
        
        console.log(qry);
        this.lstLoadQuery = qry.query;
        this.lssDesc = qry.desc;
        //this.showLoadSearch = false;
    },  
    
    // pop dialog 載入儲存的搜尋條件
    loadSaveSearch() {
        
        // 載入搜尋條件時
        let qry = this.saveSearchList.find(x=>x.name==this.selSaveSearch);
        // console.log(qry);
        // 將qry的條件, 套用到 queryConditions 和 lstQuery
        this.queryConditions = { ...qry.conditions };
        this.lstQuery = qry.query;
        this.showLoadSearch = false;
    },  
      


    // 從 queryConditions 重建 lstQuery 和映射關係（用於編輯模式）
    rebuildFromQueryConditions(conditions) {
        // 清空現有狀態
        this.lstQuery = [];
        this.queryConditionMap.clear();
        
        if (!conditions) return;
        
        // 關鍵字
        if (conditions.keyword) {
            this.lstQuery.push(conditions.keyword);
            this.queryConditionMap.set(conditions.keyword, { type: 'keyword', value: conditions.keyword });
            this.keyword = conditions.keyword;
        }
        
        // 公司狀況
        if (conditions.companyStatus) {
            this.lstQuery.push(conditions.companyStatus);
            this.queryConditionMap.set(conditions.companyStatus, { type: 'companyStatus', value: conditions.companyStatus });
        }
        
        // 公司類別（陣列）
        if (conditions.companyType && Array.isArray(conditions.companyType)) {
            conditions.companyType.forEach(type => {
                this.lstQuery.push(type);
                this.queryConditionMap.set(type, { type: 'companyType', value: type });
            });
        }
        
        // 組織別（陣列）
        if (conditions.orgType && Array.isArray(conditions.orgType)) {
            conditions.orgType.forEach(type => {
                this.lstQuery.push(type);
                this.queryConditionMap.set(type, { type: 'orgType', value: type });
            });
        }
        
        // 布林值條件
        if (conditions.isCustomer) {
            this.lstQuery.push('既有客戶');
            this.queryConditionMap.set('既有客戶', { type: 'isCustomer', value: true });
            this.IsCustomer = true;
        }
        
        if (conditions.isInvoice) {
            this.lstQuery.push('有發票');
            this.queryConditionMap.set('有發票', { type: 'isInvoice', value: true });
            this.IsInvoice = true;
        }
        
        if (conditions.isImport) {
            this.lstQuery.push('有進口');
            this.queryConditionMap.set('有進口', { type: 'isImport', value: true });
            this.IsImport = true;
        }
        
        if (conditions.isExport) {
            this.lstQuery.push('有出口');
            this.queryConditionMap.set('有出口', { type: 'isExport', value: true });
            this.IsExport = true;
        }
        
        if (conditions.isFactory) {
            this.lstQuery.push('有工廠');
            this.queryConditionMap.set('有工廠', { type: 'isFactory', value: true });
            this.IsFactory = true;
        }
        
        // 資本額
        if (conditions.capital && conditions.capital.range) {
            this.lstQuery.push(conditions.capital.range);
            this.queryConditionMap.set(conditions.capital.range, { 
                type: 'capital', 
                value: conditions.capital 
            });
        }
        
        // 設立日期
        if (conditions.setupDate && conditions.setupDate.range) {
            this.lstQuery.push(conditions.setupDate.range);
            this.queryConditionMap.set(conditions.setupDate.range, { 
                type: 'setupDate', 
                value: conditions.setupDate 
            });
        }
        
        // 行業代碼（陣列）
        if (conditions.industryCode && Array.isArray(conditions.industryCode)) {
            conditions.industryCode.forEach(code => {
                this.lstQuery.push(code);
                this.queryConditionMap.set(code, { type: 'industryCode', value: code });
            });
        }

        // 精確標籤（陣列）
        if (conditions.preciseTags && Array.isArray(conditions.preciseTags)) {
          conditions.preciseTags.forEach(tagItem => {
            const displayName = tagItem?.display_name || tagItem?.name;
            if (tagItem && tagItem.category && displayName) {
              this.addQueryCondition('preciseTag', {
                category: tagItem.category,
                display_name: displayName
              }, '', tagItem.category);
            }
          });
        }
        
        // 地址
        if (conditions.location && (conditions.location.city || conditions.location.district)) {
            const locationText = `${conditions.location.city || ''}${conditions.location.district || ''}`;
            this.lstQuery.push(locationText);
            this.queryConditionMap.set(locationText, { type: 'location', value: conditions.location });
              // 同步<DistSelection>的選擇狀態
              console.log('重建地區選擇狀態:', conditions.location);
              const _area = conditions.location.area || '全部';
              const _city = conditions.location.city;
              const _dist = conditions.location.district;
              if (_dist) {
                  this.selectedAreaValue = [_area, _city, _dist];
              } else if (_city) {
                  this.selectedAreaValue = [_area, _city];
              } else {
                  this.selectedAreaValue = [_area];
              }            
        }
        
        console.log('重建後的狀態:', {
            lstQuery: this.lstQuery,
            queryConditions: this.queryConditions,
            mapping: Array.from(this.queryConditionMap.entries())
        });
    },      

    async getBranchDist() {
      const { branchArea, branchCity, branchDist } = this.$store.state;
        
        // 只有當所有值都存在時才設置（避免 [null, null, null] 的情況）
        if (branchArea && branchCity) {
            if (branchDist) {
                this.selectedAreaValue = [branchArea, branchCity, branchDist];
            } else {
                this.selectedAreaValue = [branchArea, branchCity];
            }
            console.log("設定分行所在地區:", this.selectedAreaValue);
            
            // 等待子組件完成初始化
            await this.$nextTick();
            this.handleAreaChange(this.selectedAreaValue);
        }
    },
    
    async getFunctions() {
      // 如果 RoleName 是 HE, HD, HC, HC1  時, 才會顯示出來==> newTagForm.type='hq'
      this.userInfo = this.$store.state.userInfo;
      if( this.userInfo && this.userInfo.Role ) {
          const role = this.userInfo.Role[0].toLowerCase();
          if( role=='he' || role=='hd' || role=='hc' || role=='hc1' ) {
              this.newTagForm.type='hq';
          }

          if( role=='do' || role=='apa' || role=='ap' ) {
              this.btnAdvFuncVisible = false;            
          } else {
              this.btnAdvFuncVisible = true;
          }
      }

    },

    async getPreferences() {
        const funs = this.$store.getters.userInfo;            


        let deptInfo = {};
        // // 讀取 division_info_list
        const qry = {
            "Page_Num": 1,
            "Page_Size": 1,
            "DeptID": funs.DeptID,
            "isSys": true
        }        
        // 如果是HD及HC角色, 在分行資訊中沒有資料, 所以直接用010營業部的資料來顯示地圖, 但不帶入其他搜尋條件
        if( funs && (funs.Role[0].toLowerCase()=='hd' || funs.Role[0].toLowerCase()=='hc' || funs.Role[0].toLowerCase()=='hc1') ) {
          qry.DeptID = "999";   
			    // this.selectedAreaValue = ["北部", "臺北市", "大同區"];
          // await this.$nextTick();
          // this.handleAreaChange(this.selectedAreaValue);  
          // this.addQueryCondition('location', {
          //     city: '臺北市',
          //     district: '大同區'
          // }, '臺北市大同區');     
        }

        console.log("讀取偏好設定參數",qry);    
        await this.$api.apidivison.division_info_list(qry).then( res => {
            console.log("division_info_list API 結果:",res);
            if( res.total == 0) {     
                return;
            }
            if( res.total == 1) {
                // 保存分行坐標
                deptInfo = res.data[0];
                console.log("分行資料:", deptInfo);
                
                // 明確檢查坐標是否存在並轉換為數字
                if (deptInfo.Latitude !== null && deptInfo.Latitude !== undefined && 
                    deptInfo.Longitude !== null && deptInfo.Longitude !== undefined) {
                    this.branchLatitude = parseFloat(deptInfo.Latitude);
                    this.branchLongitude = parseFloat(deptInfo.Longitude);
                    console.log("✅ 已讀取分行坐標", { 
                        lat: this.branchLatitude, 
                        lng: this.branchLongitude,
                        原始Lat: deptInfo.Latitude,
                        原始Lng: deptInfo.Longitude
                    });
                } else {
                    console.warn("❌ 分行資料中沒有有效的坐標", { Latitude: deptInfo.Latitude, Longitude: deptInfo.Longitude });
                }
                
                // 2026-03-11, 地圖不再讀取偏好設定中的 Parameters 欄位, 直接用所在地區的設定來顯示地圖, 以避免因為偏好設定中的條件過於複雜, 而無法正確解析出地區資訊, 導致地圖無法顯示
                this.getBranchDist();
                // 讀取 Parameters 欄位，並解析成物件                
                // const paramsStr = deptInfo.Parameters;
                // if( paramsStr ) {
                //   const qc = JSON.parse(paramsStr);
                //   this.queryConditions = qc; 
                //   this.rebuildFromQueryConditions(qc);
                // }
                // else {
                //     console.warn('division_info 偏好設定中沒有 Parameters 欄位');
                //     // 若沒有 Parameters，則用所在地區, 
                //     this.getBranchDist();
                // }
            }                
        }).catch( err => {
            console.log("❌ getPreferences API 錯誤:", err);
        });   
        return deptInfo;         
    },    

    

  },
  
  // 在組件銷毀時移除事件監聽器
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    
    // 清理抽屜按鈕的事件監聽
    if (this._resizeListenerAdded) {
      window.removeEventListener('resize', this.updateToggleButtonPosition);
    }
    
    // 清理全局方法
    if (window.handleAddPotentialCustomerClick) {
      delete window.handleAddPotentialCustomerClick;
    }
    
    if (window.handleFindNearbyCustomers) {
      delete window.handleFindNearbyCustomers;
    }
    
    if (window.handleOpenAddTagDialog) {
      delete window.handleOpenAddTagDialog;
    }
  },

  async mounted() {

    // 載入熱門標籤
    await this.loadHotTags();
    // 先讀取權限設定，確保進階功能標誌正確，再載入專案名稱等需權限的資料
    await this.getFunctions();
    // 載入專案名稱選項
    this.loadProjectNameList(); 
    // 載入已儲存的搜尋條件
    this.saveSearchList = this.loadSaveSearchfromAPI();      
    // 註冊全局方法，供popup中的按鈕使用
    window.handleAddPotentialCustomerClick = this.handleAddPotentialCustomerClick;
    window.handleFindNearbyCustomers = this.handleFindNearbyCustomers;
    window.handleOpenAddTagDialog = this.handleOpenAddTagDialog;    
    // 確保初始化時就加載並顯示地圖
    this.initialMap();
    this.mapInitialized = true;    

    
    let showBranch = false;
    // 讀取 parmas 參數
    const params = this.$route.params;
    console.log('路由參數:', params);

    // 如果只給經緯度, 代表有從企業標籤搜尋點選特定公司的資訊, 將把地圖中心點設定在該公司的位置, 但不帶入其他搜尋條件
    if( params && params.searchmode && params.searchmode=='exact'  ) {      
      this.latitude = params.lat;
      this.longitude = params.lng;
      const comname = params.comname || '未知公司';
      const loc = params.loc || '';
      // console.log('僅有經緯度參數，設定地圖中心點:', { lat: this.latitude, lng: this.longitude });
      // 加入一個POI, 以顯示在地圖上
      if (this.latitude && this.longitude && this.mapObj) {
        // 清除任何可能存在的臨時標記
        if (this.activeMarker) {
          this.mapObj.removeLayer(this.activeMarker);
        }
        
        // 創建新的臨時標記 (使用紅色圖標)
        this.activeMarker = L.marker([this.latitude, this.longitude], {
          icon: this.mapConfig.redIcon,
          zIndexOffset: 1000
        }).addTo(this.mapObj);
        
        // 創建彈出視窗，參考 2106-2125 行的格式
        const popMessage = `
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; min-width: 320px;">
            <h3 style="margin: 0;">${comname}</h3>
          </div>
          ${loc ? '<br>地址：' + loc : ''}
        `;
        
        this.activeMarker.bindPopup(popMessage, {
          maxWidth: 400,
          minWidth: 320,
          className: 'custom-popup',
          autoPan: true
        }).openPopup();
      }

    } else {
      // 為了相似公司搜尋而設計的參數, 會帶入公司名稱, 經緯度, 行業代號等資訊
      if( params && params.comname ) { 

          this.clearAllQueryConditions(); // 清空條件
          
          // 如果有公司名稱參數，則設定關鍵字查詢條件
          if( params.comname && params.comname.length >0 ) {
            this.listQuery.keyword = params.comname;
            this.keyword = params.comname;        
            this.addQueryCondition('keyword', params.comname, params.comname);        
          }

          // 如果有經緯度參數，則設定地理位置查詢條件
          if( params.lng && params.lat ) {
            this.listQuery.Longitude = params.lng;
            this.listQuery.Latitude = params.lat;      
            this.latitude = params.lat;
            this.longitude = params.lng;              
            const geo = {
              Latitude: params.lat,
              Longitude: params.lng,
              Distance: "10km"          
            }
            this.addQueryCondition('geolocation', geo, `距離${geo.Distance}內`);                  
          }

          // 如果有行業代號參數，則設定行業代號查詢條件
          if( params.indusNum && params.indusNum.length >0 )
            this.addQueryCondition('industryCode', params.indusNum, params.indusNum);        


          // 預設資本額條件為 1000 萬以上
          const capital = {         
                start: '1000',
                end: '999999',
                range: '1千萬以上'         
            };
          this.addQueryCondition('capital', capital, capital.range);
          console.log('queryCondition', this.queryConditions);        
          
      }
      // 如果沒有帶入特定公司的參數，則嘗試從分行偏好設定中讀取預設的查詢條件和地圖中心點
      else { 

        // 取得分公司偏好查詢條件, 若是空的, 則利用所在地區
        this.defpInfo = await this.getPreferences();  
        console.log("getPreferences 完成，分行坐標:", { lat: this.branchLatitude, lng: this.branchLongitude });

        
        // 延遲設置地圖中心點，確保地圖完全初始化
        await this.$nextTick();
        
        // 如果讀取到分行坐標，設置地圖中心點到分行位置
        if (this.branchLatitude && this.branchLongitude && this.mapObj) {
          console.log("設置地圖中心到分行位置:", [this.branchLatitude, this.branchLongitude]);
          this.latitude = this.branchLatitude;
          this.longitude = this.branchLongitude;
          showBranch = true;
          
        } else {
          console.log("未取得分行坐標或地圖未初始化，使用預設位置");
        }
      }      
      // 取得查詢結果列表
      await this.getList();    
      
      // 如果是從分行偏好設定讀取到坐標，則在地圖上顯示分行位置的標記
      if (showBranch && this.mapObj) {
          this.mapObj.setView([this.branchLatitude, this.branchLongitude], 12);
          // 創建新的臨時標記
          this.activeMarker = L.marker([this.branchLatitude, this.branchLongitude], {
            icon: this.mapConfig.redIcon,
            zIndexOffset: 1000
          }).addTo(this.mapObj);
          
          // 創建彈出視窗，參考 2106-2125 行的格式
          const popMessage = `
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; min-width: 320px;">
              <h3 style="margin: 0;">${this.defpInfo.BranchFullName}</h3>
            </div>
            ${this.defpInfo.Address ? '<br>地址：' + this.defpInfo.Address : ''}
          `;
          
          this.activeMarker.bindPopup(popMessage, {
            maxWidth: 400,
            minWidth: 320,
            className: 'custom-popup',
            autoPan: true
          }).openPopup();        
          
      }
    }
    

      
    // 更新地圖視圖到預設位置
    if (this.mapObj) {
      // console.log("初始設置地圖中心點:", [this.latitude, this.longitude], "預設Zoom:", this.zoomDegree);
      this.mapObj.setView([this.latitude, this.longitude], this.zoomDegree);
    }



  }
};
</script>

<style lang="scss" scoped>




.comMapBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%) center center / 100% 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  
  .searchMain {
    flex: 0 0 auto; // ✅ 不伸縮，高度由內容決定
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;
    padding: 0 5%;    
    min-height: auto !important;
    
    .row1 {
      width: 100%;      
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;        
        label {
          // width: 6.25rem; /* 100px/16px = 6.25rem */          
          white-space: nowrap;          
          margin-right: 0.5rem; /* 10px/16px = 0.5rem */        
        }
      }
    }

    .rowtag {
      width: 100%;      
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;       
      margin: 0.3rem 0; /* 3px/16px = 0.1875rem */     
      flex-wrap: wrap; /* 允許標籤換行 */

      label {       
        font-size: medium;   
        white-space: nowrap;                  
      }

      .el-button {
        margin-left: 0.5rem; /* 10px/16px = 0.5rem */
      }
      
       .el-tag {
        max-width: none !important; /* 強制移除最大寬度限制 */
        flex-shrink: 0; /* 防止標籤收縮 */
        width: auto !important; /* 強制自動寬度 */
        min-width: auto !important; /* 移除最小寬度限制 */
        margin-right: 0.5rem; /* 5px/16px = 0.5rem */
      }    

    }
  }        
  
  .searchWrap {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0 5%;    
    
    .row1 {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;   
      margin: 0.5rem 0; /* 5px/16px = 0.5rem */
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;  
        margin-right: 1.25rem; /* 20px/16px = 1.25rem */
        
        label {       
          font-size: medium;   
          white-space: nowrap;          
          margin-right: 0.5rem; /* 10px/16px = 0.5rem */
          font-size: small;
        }
      }
    }

    
    .row2 {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;  
      margin: 0.5rem 0; /* 5px/16px = 0.5rem */

      .el-dropdown {
        margin-right: 1rem; /* 15px/16px = 1rem */
      }
    }    
  }
  
  .content {
    display: flex;
    flex-direction: row;    
    justify-content: flex-start;
    padding: 0 5%;
    align-items: stretch;
    
    .leftContent {      
      display: flex;
      flex-direction: column;
      width: 100%; /* 佔據整個寬度 */
      
      #map {
        width: 100%;
        height: 100%;
        min-height: 31.25rem; /* 500px/16px = 31.25rem */
        flex: 1; /* 讓地圖占滿剩餘空間 */
        border: 0.0625rem solid #000; /* 1px/16px = 0.0625rem */
        position: relative;
      }

      .map-controls {
        position: absolute;
        top: 0.5rem; /* 10px/16px = 0.5rem */
        right: 0.5rem; /* 10px/16px = 0.5rem */
        z-index: 1000;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      
      /* Google地圖風格的懸浮按鈕 - 右側中間位置 */
      .map-drawer-toggle {
        position: absolute;
        right: 0; /* 放在右側 */
        top: 50%; /* 放在垂直中間 */
        transform: translateY(-50%); /* 確保垂直居中 */
        background-color: white;
        color: #616161; /* Google地圖按鈕文字色 */
        border-radius: 0.5rem 0 0 0.5rem; /* 圓角增大，更符合Google風格 */
        padding: 0; /* 移除內邊距，統一使用高度和寬度控制大小 */
        height: 5rem; /* 與 drawer-toggle-btn 一致 */
        width: 2.5rem; /* 與 drawer-toggle-btn 一致 */
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center; /* 內容居中 */
        z-index: 2500; /* 提高層級，但低於 drawer-toggle-btn-outside */
        transition: all 0.2s ease-in-out; /* 與 drawer-toggle-btn 一致 */
        box-shadow: 0 0 0.75rem rgba(0,0,0,0.25); /* 與 drawer-toggle-btn 一致 */
        
        &:hover {
          background-color: #f5f5f5; /* Google風格的淺灰色 hover 效果 */
          box-shadow: 0 0 1rem rgba(0,0,0,0.3); /* 與 drawer-toggle-btn 一致 */
        }
        
        .button-content {
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
        }
        
        i {
          font-size: 1.5rem; /* 與 drawer-toggle-btn 一致 */
          margin: 0; /* 不需要右邊距 */
        }
        
        span {
          font-size: 0.875rem;
          font-weight: normal;
        }
      }
    }
    
    /* 抽屜內容樣式 */
    .drawer-content {      
      padding: 0.5rem;
      height: 100%;
      overflow-y: auto;

      .el-card {        
        width: 100%;
      }
    }
    
    /* 覆蓋 el-drawer 的一些默認樣式 */
    ::v-deep .el-drawer {
      overflow: visible !important; /* 確保外部元素可見 */
    }
    
    /* 防止抽屜內容水平捲動 */
    ::v-deep .el-drawer__body {
      overflow-x: hidden !important; /* 隱藏水平捲軸 */
      overflow-y: auto; /* 保持垂直捲軸 */
    }
    
    /* 縮小抽屜標題高度 */
    ::v-deep .el-drawer__header {
      padding: 8px 20px !important; /* 進一步減少上下內邊距 */
      margin-bottom: 0 !important; /* 移除底部邊距 */
      height: auto !important; /* 自動高度 */
      min-height: 36px !important; /* 減少最小高度 */
      font-size: 16px !important; /* 減小字體大小 */
      border-bottom: 1px solid #e0e0e0; /* 添加底部邊框 */
      display: flex;
      align-items: center;
    }
    
    /* 調整標題文字 */
    ::v-deep .el-drawer__header span {
      font-weight: 500;
      font-size: 0.95rem;
      color: #303133;
      line-height: 1;
    }
    
    /* 調整關閉按鈕 */
    ::v-deep .el-drawer__header button {
      padding: 0;
      width: 24px;
      height: 24px;
      line-height: 24px;
    }
    
    /* 確保關閉按鈕的圖標垂直居中 */
    ::v-deep .el-drawer__header button i {
      vertical-align: middle;
      font-size: 16px;
    }
    
    /* 抽屜外部切換按鈕樣式 - Google 地圖風格 */
    .drawer-toggle-btn-outside {
      position: fixed;
      /* 位置由JavaScript動態控制 */
      top: 50%;
      transform: translateY(-50%); /* 垂直居中 */
      width: 2.5rem; /* 按鈕寬度 */
      height: 5rem; /* 按鈕高度 */
      background-color: white;
      border-radius: 0.5rem 0 0 0.5rem; /* 左側圓角 */
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: -0.3rem 0 1rem rgba(0,0,0,0.35); /* 增強陰影效果 */
      z-index: 10001; /* 確保在抽屜上層 */
      color: #616161;
      transition: left 0.3s ease-in-out, box-shadow 0.2s ease-in-out; /* 平滑位置過渡效果 */
      
      &:hover {
        background-color: #f5f5f5;
        box-shadow: -0.35rem 0 1rem rgba(0,0,0,0.3); /* 懸停時增強陰影 */
      }
      
      i {
        font-size: 1.5rem; /* 圖標大小 */
        margin-left: -0.25rem; /* 稍微向左偏移 */
      }
    }
    
    /* 保留原來的樣式用於內部按鈕（如有需要） */
    .drawer-toggle-btn {
      position: absolute;
      left: -2.75rem;
      top: 50%;
      transform: translateY(-50%);
      width: 2.5rem;
      height: 5rem;
      background-color: white;
      border-radius: 0.5rem 0 0 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: -0.25rem 0 0.75rem rgba(0,0,0,0.25);
      z-index: 2000;
      color: #616161;
      transition: all 0.2s ease-in-out;
      
      &:hover {
        background-color: #f5f5f5;
        box-shadow: -0.35rem 0 1rem rgba(0,0,0,0.3);
      }
      
      i {
        font-size: 1.5rem;
        margin-left: -0.25rem;
      }
    }

    /* 抽屜圖標的互動效果 */
    .drawer-icon-right {
      transition: transform 0.2s ease-in-out;
    }
    .drawer-toggle-btn:hover .drawer-icon-right {
      transform: translateX(3px);
    }
    
    .drawer-icon-left {
      transition: transform 0.2s ease-in-out;
    }
    .map-drawer-toggle:hover .drawer-icon-left {
      transform: translateX(-3px);
    }

    .el-table {
      width: 100%;
      margin-top: 1rem; /* 20px/16px = 1.25rem */
    }
  }
  
  .pageBox {
    display: flex;
    flex-direction: column;    
    justify-content: flex-end;
    padding: 0px 5%;
  }  
  
  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
  }
}

/* 全域樣式，強制覆蓋 Element UI 的標籤樣式 */
.comMapBox .rowtag .el-tag.tagsClass {
  max-width: none !important;
  width: auto !important;
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: unset !important;
  display: inline-block !important;
}

.indusCodeBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 20px 10px;
  width: 100%;
  max-width: 25rem;
}

.item-number {
  display: inline-block;
  margin-right: 0.25rem;  
  color: black;
  width: 1.25rem;
  text-align: right;
}

/* 卡片內容樣式 - 更緊湊 */
.card-content {
  display: flex;
  flex-direction: column;
  padding-right: 0.5rem; /* 為右側按鈕留出空間 */
  max-width: calc(100% - 50px); /* 避免與按鈕重疊 */
}

.card-content h3 {
  margin: 0; 
  color:  #191970;
  display: flex;
  align-items: flex-start;
  font-size: 0.8rem; /* 第一行文字設為0.8rem */
  font-weight: normal;
}

.unicodeBox {
  color: green;
  flex: 1;
}

.card-branchname {
  margin: 0.1rem 0 0 1.5rem;
  color: black;
  font-size: 0.95rem; /* 稍微縮小字體 */
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-info {
  margin: 0.1rem 0 0 1.5rem;
  color: #606266;
  font-size: 0.75rem; /* 再縮小一點字體 */
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 卡片容器，用於排版內容區和按鈕區 */
.card-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start; /* 頂部對齊，以便內容區更好控制高度 */
  width: 100%;
  position: relative; /* 為按鈕定位提供參考 */
  min-height: 2rem; /* 確保至少有足夠空間放置按鈕 */
}

.card-content-wrapper {
  padding: 0.25rem 0; /* 減少內邊距 */
  display: flex;
  flex-direction: column;
  flex: 1; /* 佔據主要空間 */
  margin-right: 0.5rem; /* 在內容和按鈕之間添加一些間距 */
  min-width: 0; /* 確保內容可以被壓縮，避免溢出 */
}

/* 右側按鈕區域 */
.card-action-buttons {
  display: flex;
  flex-direction: row; /* 水平排列按鈕 */
  align-items: center;
  justify-content: flex-end; /* 靠右對齊 */
  padding-right: 0.25rem;
  gap: 0.75rem; /* 按鈕之間的水平間距 */
}

/* 圓形按鈕樣式 - 更加緊湊 */
.circular-button {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background-color: #ecf5ff;
  color: #409EFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 1px solid #d9ecff;
  transition: all 0.3s;
  /* 移除頂部邊距，讓按鈕垂直居中 */
}

/* 淺綠色圓形按鈕樣式 - 區別右邊的按鈕 */
.circular-button-green {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background-color: #f0f9ff;
  color: #67c23a;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 1px solid #c2e7b0;
  transition: all 0.3s;
  /* 移除頂部邊距，讓按鈕垂直居中 */
}

.circular-button:hover {
  background-color: #409EFF;
  color: white;
}

.circular-button-green:hover {
  background-color: #67c23a;
  color: white;
}

.circular-button i {
  font-size: 0.9rem; /* 稍微縮小圖標 */
}

.circular-button-green i {
  font-size: 0.9rem; /* 稍微縮小圖標 */
}

/* 按鈕下方的標籤文字 - 改為緊貼按鈕下方 */
.button-label {
  font-size: 0.55rem;
  color: #606266;
  position: absolute;
  bottom: -0.9rem;
  text-align: center;
  width: 100%;
  line-height: 1;
}

/* 添加緊湊型卡片樣式 */
.compact-card ::v-deep .el-card__body {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}



/* 標籤抽屜樣式 */
.tag-drawer-content {
  padding: 1rem;
  height: 100%;
  overflow-y: auto;
}

.company-info-section,
.tags-section {
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #409EFF;
}

.section-title {
  margin: 0 0 1rem 0;
  color: #303133;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title i {
  color: #409EFF;
  font-size: 1rem;
}

.company-details {
  line-height: 0.8;
}

.company-details p {
  margin: 0.5rem 0;
  color: #606266;
}

.company-details strong {
  color: #303133;
  font-weight: 500;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: flex-start;
}

.tag-item {
  margin: 0;
  font-size: 0.875rem;
  padding: 0.25rem 0.75rem;
  border-radius: 16px;
  width: auto;
  min-width: auto;
  max-width: none;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

.no-tags {
  color: #909399;
  font-style: italic;
}

/* 自定義彈出窗口樣式 */
:global(.custom-popup) {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

:global(.custom-popup .leaflet-popup-content-wrapper) {
  border-radius: 8px;
  box-shadow: 0 3px 14px rgba(0,0,0,0.2);
  padding: 2px;
}

:global(.custom-popup .leaflet-popup-content) {
  margin: 12px 16px;
  min-width: 320px;
}

/* 標籤表單樣式 */
.tag-form {
  padding: 1rem;
}

.form-item {
  margin-bottom: 1.5rem;
}

.form-item label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #606266;
}

.company-name {
  padding: 0.5rem;
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background-color: #f5f7fa;
  border-radius: 4px;
  width: 100%;
}

.no-tags-message {
  text-align: center;
  padding: 2rem;
  color: #909399;
}

.tag-actions {
  position: sticky;
  bottom: 0;
  background-color: white;
  padding: 1rem 0;
  border-top: 1px solid #ebeef5;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.tag-actions .el-button {
  min-width: auto;
}

/* 覆蓋左側抽屜的一些默認樣式 */
::v-deep .el-drawer.ltr {
  border-radius: 0 8px 8px 0;
}

::v-deep .el-drawer.ltr .el-drawer__header {
  padding: 16px 20px;
  margin-bottom: 0;
  border-bottom: 1px solid #ebeef5;
  background-color: #fafafa;
}

::v-deep .el-drawer.ltr .el-drawer__header span {
  font-weight: 600;
  color: #303133;
}

::v-deep .el-drawer.ltr .el-drawer__body {
  padding: 0;
}


</style>

<style>
/* 增加全局樣式，確保多選下拉框不折行 */
.flexible-select .el-tag {
  margin: 2px 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flexible-select.el-select .el-select__tags {
  flex-wrap: nowrap;
  overflow-x: auto;
  max-width: 100%;
  padding-right: 30px; /* 為箭頭留出空間 */
  scrollbar-width: thin; /* Firefox */
}

/* 為 Webkit 瀏覽器設定滾動條樣式 */
.flexible-select.el-select .el-select__tags::-webkit-scrollbar {
  height: 4px;
}

.flexible-select.el-select .el-select__tags::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}

/* 調整 dropdown 選單與觸發按鈕之間的間距 */
.el-dropdown-menu {
  margin-top: 5px !important;
}

/* 加深 checkbox 方框邊框顏色 */
.el-checkbox__inner {
  border-color: #606266 !important;
  border-width: 1.5px !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}
</style>
